import React, { useState, useEffect, useRef } from "react";
import "../css/wb_add_template.css";
import Cropper from "cropperjs";
import "cropperjs/dist/cropper.css";
import { apiCall } from "../services/authServieces";
import easygobanner from "../Assets/images/b9364548-0ff5-4ba5-9416-3744e0088e28.jpg";
import easygologo from "../Assets/images/easygo.jpg";
import call from "../Assets/images/phone-call.png";
import internet from "../Assets/images/internet.png";
import email from "../Assets/images/email.png";
import call1 from "../Assets/images/phone-call1.png";
import internet1 from "../Assets/images/internet1.png";
import email1 from "../Assets/images/email1.png";
import pdffileicon from "../Assets/images/pdf_icon.png";
import { ClipLoader } from "react-spinners";
import { json } from "react-router-dom";
import thumbnail from "../Assets/images/thumbnail_imgRS.jpg";
import thumbnailCarousel from "../Assets/images/thumbnail_imgCarousel.jpg";
import mediaFileTest from "../Assets/images/cropped-img1.png";
import { Co2Sharp } from "@mui/icons-material";
import Compressor from 'compressorjs';
import imageCompression from 'browser-image-compression';

function WbAddTemplate1() {
  const [templateName1, setTemplateName1] = useState('');
  const [cardTitle, setCardTitle] = useState('');
  const [cardTitle1, setCardTitle1] = useState('');
  const [CardTitleDes, setCardTitleDes] = useState('');
  const [CardTitleDes1, setCardTitleDes1] = useState('');
  const [CardTitleDes2, setCardTitleDes2] = useState('');
  const [CardTitleDes3, setCardTitleDes3] = useState('');
  const [pdffile, setpdffile] = useState('');
  const [isCategory, setIsCategory] = useState('rich_card');
  const [loading, setLoading] = useState(false);

  // Nikhil start RichCardAlone

  const [RcAloneOrientation, setRcAloneOrientation] = useState('VERTICAL')

  const [rcaFileUrl, setrcaFileUrl] = useState("")
  // Nikhil end RichCardAlone
  const [cardWidth, setCardWidth] = useState("SMALL_WIDTH")



  const maxChars = 20;
  const maxChars1 = 200;
  const maxChars2 = 2000;
  const maxChars4 = 2000;
  const maxChars3 = 200;
  const maxChars5 = 2000;
  const maxChars6 = 2000;

  const maxchar25 = 25;
  const maxchar120 = 120;
  const maxchar1024 = 1024;
  const maxchar2048 = 2048;
  const maxChar13 = 13;



  const [showModal, setShowModal] = useState(false);
  const [showModalpdf, setShowModalpdf] = useState(false);
  const [selectedFile, setSelectedFile] = useState(null);
  const [selectedFile1, setSelectedFile1] = useState(null);
  const [rediopdf, setrediopdf] = useState('pdf_at_top');

  // const [orientation, setOrientation] = useState("VERTICAL");
  const [activeTab, setActiveTab] = useState("image");
  const [fileURL, setFileURL] = useState("");
  const [mediaHeight, setMediaHeight] = useState("SHORT_HEIGHT");
  const [mediaHeight1, setMediaHeight1] = useState("SHORT_HEIGHT");
  const [horizontalPosition, setHorizontalPosition] = useState("LEFT");
  const [selectedFileName, setSelectedFileName] = useState("");

  const [selectedFileName1, setSelectedFileName1] = useState("");
  // const [suggestions, setSuggestions] = useState([]);
  // const [selectedAction, setSelectedAction] = useState("");
  const variableText = "[user_param]";

  const [selectedCardId, setSelectedCardId] = useState(1 || null);

  const [nextId, setNextId] = useState({
    rich_card: { id: 1 },
    carousel: [
      {
        card_number: 1,
        id: 1
      },
      {
        card_number: 2,
        id: 1
      }
    ],
    text_message: { id: 1 },
    text_message_with_pdf: { id: 1 },
  });



  // girija 

  const [cropperInstance, setCropperInstance] = useState(null);
  const [imageSrc, setImageSrc] = useState(null);
  const [previewSrc, setPreviewSrc] = useState(null);
  const [fileName, setFileName] = useState("");
  const imageRef = useRef(null);
  const [selectedClass, setSelectedClass] = useState("HORIZONTAL");
  const [previewURL, setPreviewURL] = useState("");
  const [mediaType, setMediaType] = useState("image");
  const [activeScreenTab, setActiveScreenTab] = useState('conversation');
  const [selectedTab, setSelectedTab] = useState('infoTab');
  const [VedioData, setVedioData] = useState('');
  const [VedioDataurl, setVedioDataurl] = useState('');
  const [VedioDataurlname, setVedioDataurlname] = useState('');
  const thumbnailRef = useRef(null);
  const thumbnailCarouselRef = useRef(null);

  const mediaFileTestRef = useRef(null);

  const [uploadfile, setuploadfile] = useState([
    { activestate: "image", url: '', file: '' },
    { activestate: "url", url: '', file: '' },
    { activestate: "videoUrl", url: '', file: '' }
    ,

  ]);



  const initializeCropper = (src) => {
    let cropBoxWidth, cropBoxHeight;

    // If there is an existing cropper instance, destroy it before creating a new one
    if (cropperInstance) {
      cropperInstance.destroy();
    }

    // Check if the source is a video and set timeout for initializing the cropper
    if (src === "video") {
      setTimeout(() => {
        setCropperInstance();
      }, 0);
    }

    if (isCategory === "rich_card") {
      // Set timeout to initialize the cropper instance
      setTimeout(() => {
        const image = imageRef.current;
        let newCropper;
        if (RcAloneOrientation === "HORIZONTAL") {
          newCropper = new Cropper(image, {
            aspectRatio: 3 / 4, // Set aspect ratio to 3:1 (height:width)
            viewMode: 1, // Set to 1 for fixed crop box within the container
            // minContainerHeight: cropBoxHeight, // Fixed height
            cropBoxResizable: true, // Allow resizing of crop box
            dragMode: 'move', // Allow moving the crop box
            ready() {
              // Optionally, you can log when the cropper is ready or perform additional setup here
              // console.log('Cropper is ready');
            },
          });

        } else if (RcAloneOrientation === "VERTICAL") {

          let aspect = 3; // default for SHORT
          let autoCropArea = 0.6; // default crop area

          if (mediaHeight === "SHORT_HEIGHT") {
            aspect = 3;            // same as now
            autoCropArea = 0.6;    // smaller crop
          }
          else if (mediaHeight === "MEDIUM_HEIGHT") {
            aspect = NaN;          // 🔥 allow free resize (full image)
            autoCropArea = 1;      // 🔥 use full image
          }

          newCropper = new Cropper(image, {
            aspectRatio: aspect, // Set aspect ratio to 3:1 (height:width)
            viewMode: 1, // Set to 1 for fixed crop box within the container
            // minContainerHeight: cropBoxHeight, // Fixed height
            cropBoxResizable: true, // Allow resizing of crop box
            dragMode: 'move', // Allow moving the crop box
            ready() {
              // Optionally, you can log when the cropper is ready or perform additional setup here
              // console.log('Cropper is ready');
            },
          });

        }

        // // nikhil
        // console.log('image: ', image);

        setCropperInstance(newCropper);
      }, 0);

    }

    else if (isCategory === "carousel") {
      // Set timeout to initialize the cropper instance
      setTimeout(() => {
        const image = imageRef.current;

        console.log("ok");

        let autoCropArea = 1; // carousel images should use full area
        let aspectRatio;


        console.log(cardWidth,"cardWidth",mediaHeight1,"mediaHeight1");

        // ---- SMALL + SMALL ----
        if (cardWidth === "SMALL_WIDTH" && mediaHeight1 === "SHORT_HEIGHT") {
          aspectRatio = 5 / 4;   // 960x720
        }

        // ---- SMALL + MEDIUM ----
        else if (cardWidth === "SMALL_WIDTH" && mediaHeight1 === "MEDIUM_HEIGHT") {
          aspectRatio = 4 / 5;   // 576x720
        }

        // ---- MEDIUM + SMALL ----
        else if (mediaHeight1 === "SHORT_HEIGHT" && cardWidth === "MEDIUM_WIDTH") {
          aspectRatio = 2 / 1;   // 1440x720
        }

        // ---- MEDIUM + MEDIUM ----
        else if (mediaHeight1 === "MEDIUM_HEIGHT" && cardWidth === "MEDIUM_WIDTH") {
          aspectRatio = 1.34;   // 1440x1080
        }

console.log("check");
      
      const newCropper = new Cropper(image, {
        aspectRatio:aspectRatio, // Set aspect ratio to 5:4 (height:width)
        viewMode: 1, // Set to 1 for fixed crop box within the container
        // minContainerHeight: cropBoxHeight, // Fixed height
        cropBoxResizable: true, // Allow resizing of crop box
        dragMode: 'move', // Allow moving the crop box
        ready() {
          // Optionally, you can log when the cropper is ready or perform additional setup here
          // console.log('Cropper is ready');
        },
      });
      setCropperInstance(newCropper);
    }, 0);
    }


  };

  // Compress Image
  const compressImage = async (file, maxSizeMB = 1) => {
    const maxSizeBytes = maxSizeMB * 1024 * 1024; // Convert MB to bytes
    let quality = 0.9; // Start with high quality
    const step = 0.1; // Decrease quality in steps

    return new Promise((resolve, reject) => {
      const reader = new FileReader();

      reader.onload = (event) => {
        const img = new Image();
        img.src = event.target.result;

        img.onload = async () => {
          const canvas = document.createElement('canvas');
          canvas.width = img.width; // Keep original width
          canvas.height = img.height; // Keep original height

          const ctx = canvas.getContext('2d');
          ctx.drawImage(img, 0, 0, canvas.width, canvas.height);

          let compressedBlob;

          // Iteratively reduce quality until file size is below the limit
          do {
            compressedBlob = await new Promise((resolve) => {
              canvas.toBlob(
                (blob) => {
                  resolve(blob);
                },
                'image/jpeg', // Format
                quality // Compression quality
              );
            });

            if (compressedBlob.size <= maxSizeBytes) {
              break; // Stop if within size limit
            }

            quality -= step; // Decrease quality for further compression
          } while (quality > 0);

          if (compressedBlob.size > maxSizeBytes) {
            reject(new Error('Unable to compress below the specified size.'));
          } else {
            // Convert Blob to File and return
            const compressedFile = new File([compressedBlob], file.name, {
              type: file.type,
              lastModified: Date.now(),
            });
            resolve(compressedFile);
          }
        };

        img.onerror = (error) => reject(error);
      };

      reader.onerror = (error) => reject(error);

      // Read the file as a Data URL
      reader.readAsDataURL(file);
    });
  };




  const handleAspectRatio = (ratio) => {
    if (cropperInstance) {
      cropperInstance.setAspectRatio(ratio === "Free" ? NaN : eval(ratio));
    }
  };


  // Function to handle the radio button click
  const rediobuttonforpdf = (e) => {
    const value = e.target.value;

    // Update the state
    setrediopdf(value);
  };

  // Using useEffect to log the value after state has been updated
  useEffect(() => {
    // console.log(rediopdf, 'rediobutton value after state update');
  }, [rediopdf]); // This will run when `rediopdf` state changes



  // Function to handle the preview of the cropped image
  const handlePreview = async () => {
    try {
      setLoading(true)

      if (VedioData) {
        // console.log('VedioData:11111111 ', VedioData);


        // Extract base64 data from canvas (Assuming VedioData is a canvas)
        const canvas = VedioData;  // Get the cropped canvas
        if (canvas) {
          const croppedImageUrl = canvas;  // Get the base64 URL of the cropped image or video
          // console.log(croppedImageUrl);

          setPreviewSrc(croppedImageUrl);  // Display preview of cropped content

          // Convert Data URL (from canvas) to File object
          dataURLToFile(croppedImageUrl, selectedFileName) // Use selectedFileName for dynamic file name
            .then((file) => {
              // Check if file is successfully created
              if (file) {

                // Set the cropped image/video file to be sent to backend
                setrcaFileUrl(file);  // This is the file you can send to the backend
                setSelectedFile(file)
                // Optionally close the modal (if required)
                setShowModal(false);
              } else {
                console.error('Error creating file');
              }
            })
            .catch((error) => {
              console.error('Error converting data URL to file:', error);
            });
        }
      }

      if (cropperInstance) {

        const canvas = cropperInstance.getCroppedCanvas({
          width: 1440,
          height: 480
        });


        if (canvas) {
          // Use canvas.toBlob to generate a file directly without base64 overhead
          canvas.toBlob(
            (blob) => {
              if (blob) {
                const file = new File([blob], selectedFileName, { type: blob.type });
                // console.log('File after cropping: ', file);

                // Set the cropped file in the state
                setPreviewSrc(canvas.toDataURL());
                setSelectedFile(file);
                setrcaFileUrl(file);

                // Optionally close the modal
                setShowModal(false);
              }
            },
            'image/jpeg', // Output format (jpeg, png, etc.)
            1 // Compression quality (0.1 to 1.0)
          );
        }
        // if (canvas) {
        //   const croppedImageUrl = canvas.toDataURL();  // Get the base64 URL of the cropped image
        //   setPreviewSrc(croppedImageUrl)
        //   console.log('selectedFileName: ', selectedFileName);
        //   // Convert the Data URL to a File object
        //   let file = dataURLToFile(croppedImageUrl, selectedFileName);  // Use selectedFileName for dynamic file name
        //   console.log('__________file______________: ', file);

        //   // Compress file size (file, fileSize)
        //   // file = await compressImage(file, 2)

        //   setSelectedFile(file)
        //   // Set the cropped image file in the state (which you can send to the backend)
        //   setrcaFileUrl(file);


        //   // Optionally close the modal (if required)
        //   setShowModal(false);
        // }



      }

    }
    catch (error) {
      console.log("Error:", error)
      throw error
    }
    finally {
      setLoading(false)
    }
  };




  // Function to convert Data URL to File
  const dataURLToFile = (dataUrl, filename) => {
    // Handle base64 image
    if (dataUrl.startsWith('data:image')) {
      const arr = dataUrl.split(',');
      const mime = arr[0].match(/:(.*?);/)[1]; // Extract MIME type
      const byteStr = atob(arr[1]); // Decode the base64 string to binary
      const byteArray = new Uint8Array(byteStr.length);

      for (let i = 0; i < byteStr.length; i++) {
        byteArray[i] = byteStr.charCodeAt(i);
      }

      // Create a Blob and return the File object
      const blob = new Blob([byteArray], { type: mime });
      const file = new File([blob], filename, { type: mime, lastModified: Date.now() });
      return file;
    }
    // Handle video URL or base64
    else if (dataUrl.startsWith('data:video') || dataUrl.startsWith('http')) {
      return fetch(dataUrl)
        .then(response => {
          if (!response.ok) {
            throw new Error('Failed to fetch video');
          }
          return response.blob();
        })
        .then(blob => {
          const videoFile = new File([blob], filename, { type: blob.type, lastModified: Date.now(), dataUrl: dataUrl });
          return videoFile;
        })
        .catch(error => {
          console.error('Error fetching video: ', error);
          return null;
        });
    }
    // Handle Blob URL (blob:)
    else if (dataUrl.startsWith('blob:')) {
      return fetch(dataUrl)
        .then(response => {
          if (!response.ok) {
            throw new Error('Failed to fetch blob');
          }
          return response.blob();
        })
        .then(blob => {
          const file = new File([blob], filename, { type: blob.type, lastModified: Date.now() });
          return file;
        })
        .catch(error => {
          console.error('Error fetching blob: ', error);
          return null;
        });
    } else {
      throw new Error('Invalid data URL type');
    }
  };


  // Function to read file as Data URL
  const readFileAsDataURL = (file) => {
    return new Promise((resolve, reject) => {
      const reader = new FileReader();
      reader.onloadend = () => resolve(reader.result); // Return the Data URL when done
      reader.onerror = reject; // Reject if error occurs during reading
      reader.readAsDataURL(file);
    });
  };

  // Function to process file and convert to Data URL then back to File
  const processFile = async (file, filename) => {
    try {
      // Read file as Data URL
      const dataUrl = await readFileAsDataURL(file);

      // Convert the Data URL back to a File
      const resultFile = await dataURLToFile(dataUrl, filename);

      // Return the result file or do something with it
      return resultFile;
    } catch (error) {
      console.error('Error processing file:', error);
      return null;
    }
  };




  const isValidMediaURL = (url) => {
    return /\.(jpeg|jpg|png|gif|mp4|webm|ogg)$/i.test(url);
  };

  const handleSelectChange = (event) => {
    setrcaFileUrl('')
    setSelectedFile('')
    setPreviewSrc('')
    const value = event.target.value;
    setRcAloneOrientation(value);
  };
  // nikhil suggestion work 


  const richCardValidation = async () => {
    if (!templateName1.trim()) {
      alert('Please Fill Template Name');
      return false
    }
    if (!isCategory.trim()) {
      alert('Please Select Template Type');
      return false
    }
    if (!RcAloneOrientation.trim()) {
      alert('Please Select Card Orientation');
      return false
    }
    if (RcAloneOrientation === "VERTICAL") {
      if (!mediaHeight.trim()) {
        alert('Please Select Media Height');
        return false
      }
    } else if (RcAloneOrientation === "HORIZONTAL") {
      if (!horizontalPosition.trim()) {
        alert('Please Select Horizontal Position');
        return false
      }
    }

    if (!rcaFileUrl) {
      alert('Please Upload File First');
      return false
    }
    if (!cardTitle.trim()) {
      alert('Please Enter Card Title');
      return false
    }
    if (!CardTitleDes.trim()) {
      alert('Please Enter Card Description');
      return false
    }
    return true
  }


  const textMessageValidation = async () => {
    if (!templateName1.trim()) {
      alert('Please Fill Template Name');
      return false
    }
    if (!isCategory.trim()) {
      alert('Please Select Template Type');
      return false
    }
    if (!CardTitleDes2.trim()) {
      alert('Please Fill Message Content');
      return false
    }

    return true
  }
  const textMessagePdfValidation = async () => {
    if (!templateName1.trim()) {
      alert('Please Fill Template Name');
      return false
    }
    if (!isCategory.trim()) {
      alert('Please Select Template Type');
      return false
    }
    if (!CardTitleDes3.trim()) {
      alert('Please Fill Message body');
      return false
    }
    if (!rediopdf.trim()) {
      alert('Please Select PDF position');
      return false
    }

    return true
  }

  const suggestionValidation = async (suggestionAry) => {
    // console.log("suggestionAry: ", suggestionAry);
    // console.log("suggestionAry length: ", suggestionAry.suggestion.length);

    if (suggestionAry.suggestion.length > 0) {
      // Using some to stop at the first failure
      const hasError = suggestionAry.suggestion.some((suggestionElt) => {
        const selectedActionValue = suggestionElt.selectedAction?.trim();

        if (!selectedActionValue) {
          alert("Please Select Type Of Action");
          return true; // Stops iteration and marks validation as failed
        }

        if (selectedActionValue === "URL_Action" && !suggestionElt.urlAction.trim()) {
          alert("Please Enter URL Action");
          return true;
        }

        if (selectedActionValue === "URL_Action" && suggestionElt.urlAction.trim()) {
          let urlInput = suggestionElt.urlAction
          let isValidUrl = (urlInput) => {
            const regex = /^(https?:\/\/)?([\w-]+(\.[\w-]+)+)(:[0-9]+)?(\/.*)?$/i;
            return regex.test(urlInput);
          }
          if (!isValidUrl(urlInput)) {
            alert("Please Enter Vaild URL");
            return true;
          }
        }

        if (selectedActionValue === "Dialer_Action" && !suggestionElt.dialerAction.trim()) {
          alert("Please Enter Phone Number to Dial");
          return true;
        }

        if (selectedActionValue === "View_Location") {
          if (!suggestionElt.latitude.trim()) {
            alert("Please Enter Latitude");
            return true;
          }
          if (!suggestionElt.longitude.trim()) {
            alert("Please Enter Longitude");
            return true;
          }
          if (!suggestionElt.label.trim()) {
            alert("Please Enter Label");
            return true;
          }
        }
        if (selectedActionValue === "Create_Calendar_Event") {
          if (!suggestionElt.eventDateTime.trim()) {
            alert("Please Select Event Date & Time");
            return true;
          }
          if (!suggestionElt.eventTitle.trim()) {
            alert("Please Enter Event Title");
            return true;
          }
          if (!suggestionElt.eventDescription.trim()) {
            alert("Please Enter Event Description");
            return true;
          }
        }

        if (!suggestionElt.suggestionText?.trim()) {
          alert("Please Fill Suggestion Text");
          return true;
        }

        if (!suggestionElt.suggestionPostback?.trim()) {
          alert("Please Fill Suggestion Postback");
          return true;
        }

        return false; // No error found, continue iteration
      });

      if (hasError) {
        // console.log('hasError: ', hasError);
        return false; // Validation failed
      }
    }

    return true; // All validations passed
  };

  const suggestionCarouselValidation = async (suggestionAry) => {
    // console.log("suggestionAry: ", suggestionAry);

    // Iterate through each card in the array
    for (const card of suggestionAry) {
      // console.log(`Validating card number: ${card.card_number}`);

      if (card.suggestion.length > 0) {
        // Check suggestions for the current card
        const hasError = card.suggestion.some((suggestionElt) => {
          const selectedActionValue = suggestionElt.selectedAction?.trim();

          if (!selectedActionValue) {
            alert(`Card ${card.card_number}: Please Select Type Of Action`);
            return true;
          }

          if (selectedActionValue === "URL_Action" && !suggestionElt.urlAction) {
            alert(`Card ${card.card_number}: Please Enter URL Action`);
            return true;
          }

          if (selectedActionValue === "Dialer_Action" && !suggestionElt.dialerAction) {
            alert(`Card ${card.card_number}: Please Enter Phone Number to Dial`);
            return true;
          }

          if (selectedActionValue === "View_Location") {
            if (!suggestionElt.latitude) {
              alert(`Card ${card.card_number}: Please Enter Latitude`);
              return true;
            }
            if (!suggestionElt.longitude) {
              alert(`Card ${card.card_number}: Please Enter Longitude`);
              return true;
            }
            if (!suggestionElt.label) {
              alert(`Card ${card.card_number}: Please Enter Label`);
              return true;
            }
          }

          if (!suggestionElt.suggestionText?.trim()) {
            alert(`Card ${card.card_number}: Please Fill Suggestion Text`);
            return true;
          }

          if (!suggestionElt.suggestionPostback?.trim()) {
            alert(`Card ${card.card_number}: Please Fill Suggestion Postback`);
            return true;
          }

          return false; // No error found, continue iteration
        });

        if (hasError) {
          // console.log(`Validation failed for card number: ${card.card_number}`);
          return false; // Validation failed
        }
      }
    }

    // console.log("All cards passed validation");
    return true; // All validations passed
  };


  const cardsDataValidation = async (cardsData) => {
    // console.log("Validating cards data: ", cardsData);

    for (const card of cardsData) {
      // console.log(`Validating card ID: ${card.id}`);

      // Validate title
      if (!card.title?.trim()) {
        alert(`Card ID ${card.id}: Please Fill Card Title`);
        return false; // Validation failed
      }

      // Validate description
      if (!card.description?.trim()) {
        alert(`Card ID ${card.id}: Please Fill Card Description`);
        return false; // Validation failed
      }

      // Optional fields (card_width, media_height, image) are not validated here
      // console.log(`Card ID ${card.id} passed validation`);
    }

    // console.log("All cards passed validation");
    return true; // All validations passed
  };



  async function validateCardSuggestions(data, selectedCardId) {
    let errorMessages = [];

    // Function to validate a specific card's fields and suggestions
    function validateCard(card) {
      const { id, title, description, image, suggestion } = card;

      // Check if title and description are present
      if (!title.trim()) {
        errorMessages.push(`Card ID ${id}: Please Enter title.`);
        return false;
      }
      else if (!description.trim()) {
        errorMessages.push(`Card ID ${id}: Please Enter description.`);
        return false;
      }
      else if (!image) {
        errorMessages.push(`Card ID ${id}: Please Upload Image.`);
        return false;
      }



      // If suggestion array exists and is not empty, validate suggestion fields
      if (Array.isArray(suggestion) && suggestion.length > 0) {
        // Validate each suggestion in the list
        for (const sug of suggestion) {
          const {
            selectedAction,
            suggestionText,
            suggestionPostback
          } = sug;

          // Check if selectedAction exists and is not empty
          if (!selectedAction || !selectedAction.trim()) {
            errorMessages.push(`Card ID ${id}: Missing selectedAction field.`);
            return false;
          }

          // Validate based on selectedAction
          switch (selectedAction) {
            case "Reply":
              if (!suggestionText.trim()) {
                errorMessages.push(`Card ID ${id}: Suggestion Text field empty in Reply action.`);
                return false;
              }
              else if (!suggestionPostback.trim()) {
                errorMessages.push(`Card ID ${id}: Suggestion Postback field empty in Reply action.`);
                return false;
              }
              break;

            case "URL_Action":
              if (!suggestionText.trim()) {
                errorMessages.push(`Card ID ${id}: Suggestion Text field empty in URL_Action.`);
                return false;
              }
              else if (!suggestionPostback.trim()) {
                errorMessages.push(`Card ID ${id}: Suggestion Postback field empty in URL_Action.`);
                return false;
              }
              else if (!sug.urlAction.trim()) {
                errorMessages.push(`Card ID ${id}: URL field empty in URL_Action.`);
                return false;
              }
              break;

            case "Dialer_Action":
              if (!suggestionText.trim()) {
                errorMessages.push(`Card ID ${id}: Suggestion Text field empty in Dialer_Action.`);
                return false;
              }
              else if (!suggestionPostback.trim()) {
                errorMessages.push(`Card ID ${id}: Suggestion Postback field empty in Dialer_Action.`);
                return false;
              }
              else if (!sug.dialerAction.trim()) {
                errorMessages.push(`Card ID ${id}: Phone Number to Dial field empty in Dialer_Action.`);
                return false;
              }
              break;

            case "View_Location":

              if (!suggestionText.trim()) {
                errorMessages.push(`Card ID ${id}: Suggestion Text field empty in View_Location.`);
                return false;
              }
              else if (!suggestionPostback.trim()) {
                errorMessages.push(`Card ID ${id}: Suggestion Postback field empty in View_Location.`);
                return false;
              }
              else if (!sug.latitude.trim()) {
                errorMessages.push(`Card ID ${id}: Latitude field empty in View_Location.`);
                return false;
              }
              else if (!sug.longitude.trim()) {
                errorMessages.push(`Card ID ${id}: Longitude field empty in View_Location.`);
                return false;
              }
              else if (!sug.label.trim()) {
                errorMessages.push(`Card ID ${id}: Label field empty in View_Location.`);
                return false;
              }
              break;

            case "View_Location_Query":
              if (!suggestionText.trim()) {
                errorMessages.push(`Card ID ${id}: Suggestion Text field empty in View_Location_Query.`);
                return false;
              }
              else if (!suggestionPostback.trim()) {
                errorMessages.push(`Card ID ${id}: Suggestion Postback field empty in View_Location_Query.`);
                return false;
              }
              break;

            case "Share_Location":
              if (!suggestionText.trim()) {
                errorMessages.push(`Card ID ${id}: Suggestion Text field empty in Share_Location.`);
                return false;
              }
              else if (!suggestionPostback.trim()) {
                errorMessages.push(`Card ID ${id}: Suggestion Postback field empty in Share_Location.`);
                return false;
              }
              break;

            case "Create_Calendar_Event":
              if (!suggestionText.trim()) {
                errorMessages.push(`Card ID ${id}: Suggestion Text field empty in Create_Calendar_Event.`);
                return false;
              }
              else if (!suggestionPostback.trim()) {
                errorMessages.push(`Card ID ${id}: Suggestion Postback field empty in Create_Calendar_Event.`);
                // console.log('qqqqqqqqqqqqqqq', sug.eventDateTime)
                return false;
              }
              else if (!sug.eventDateTime.trim()) {
                errorMessages.push(`Card ID ${id}: Event Date & Time field empty in Create_Calendar_Event.`);
                return false;
              }
              else if (!sug.eventTitle.trim()) {
                errorMessages.push(`Card ID ${id}: Event Title field empty in Create_Calendar_Event.`);
                return false;
              }
              else if (!sug.eventDescription.trim()) {
                errorMessages.push(`Card ID ${id}: Event Description field empty in Create_Calendar_Event.`);
                return false;
              }
              break;

            default:
              errorMessages.push(`Card ID ${id}: Unknown selectedAction ${selectedAction}.`);
              return false;
          }
        }
      }

      return true;
    }

    // Validate the active card first
    // const activeCard = data.find(card => card.id === selectedCardId);
    const activeCard = data.find((card) => {
      // console.log('card_1111', card)
      // console.log('card.id:', card.id)
      return card.id === selectedCardId
    });
    // console.log('activeCard: ', activeCard);
    if (!activeCard) {
      errorMessages.push(`Active card ID ${selectedCardId} not found.`);
      alert(errorMessages.join("\n"));
      return false;
    }

    // Validate active card
    const isActiveValid = validateCard(activeCard);
    if (!isActiveValid) {
      alert(errorMessages.join("\n"));
      return false;  // Return early if active card validation fails
    }

    // If active card is valid, validate all other cards
    for (const card of data) {
      if (card.id !== selectedCardId) {
        const isValid = validateCard(card);
        if (!isValid) {
          alert(errorMessages.join("\n"));
          return false;
        }
      }
    }

    // If no errors, all cards are valid
    // alert("All validations passed.");
    return true;
  }


  const resetTemplateFields = () => {
    if (isCategory === "rich_card") {
      setTemplateName1("")
      setRcAloneOrientation("VERTICAL")
      setMediaHeight("SHORT_HEIGHT")
      setCardTitle("")
      setCardTitleDes("")

      setSelectedFileName('')
      setrcaFileUrl('')
      setPreviewURL('')
      setImageSrc('')
      setPreviewSrc('')

      setSuggestions((prevSugItems) => {
        return {
          ...prevSugItems,
          [isCategory]: {
            ...prevSugItems[isCategory],
            card_suggestion: [],
            suggestion: []
          }
        }
      })
      setNextId((prevNextId) => {
        return {
          ...prevNextId,
          [isCategory]: {
            ...prevNextId[isCategory],
            id: 1
          }
        }
      })

    }
    else if (isCategory === "carousel") {
      setTemplateName1("")
      setSelectedFileName("")
      setCards([
        { id: 1, title: "", description: "", image: null, dataurl: null, mediaType: null },
        { id: 2, title: "", description: "", image: null, dataurl: null, mediaType: null },
      ])
      setSuggestions((prevSugItems) => {
        return {
          ...prevSugItems,
          [isCategory]: {
            ...prevSugItems[isCategory],
            card_suggestion: [],
            suggestion: []
          }
        }
      })
      setNextId((prevNextId) => {
        return {
          ...prevNextId,
          [isCategory]: [
            {
              card_number: 1,
              id: 1
            },
            {
              card_number: 2,
              id: 1
            }
          ]
        }
      })

    }
    else if (isCategory === "text_message") {
      setTemplateName1("")
      setCardTitleDes2("")
      setSuggestions((prevSugItems) => {
        return {
          ...prevSugItems,
          [isCategory]: {
            ...prevSugItems[isCategory],
            card_suggestion: [],
            suggestion: []
          }
        }
      })
      setNextId((prevNextId) => {
        return {
          ...prevNextId,
          [isCategory]: {
            ...prevNextId[isCategory],
            id: 1
          }
        }
      })

    }
    else if (isCategory === "text_message_with_pdf") {
      setTemplateName1("")
      setrcaFileUrl("")
      setCardTitleDes3("")
      setPreviewSrc("")
      setSuggestions((prevSugItems) => {
        return {
          ...prevSugItems,
          [isCategory]: {
            ...prevSugItems[isCategory],
            card_suggestion: [],
            suggestion: []
          }
        }
      })
      setNextId((prevNextId) => {
        return {
          ...prevNextId,
          [isCategory]: {
            ...prevNextId[isCategory],
            id: 1
          }
        }
      })

    }

  }

  // convert base64 to File object
  async function base64ToFile(base64String, filename) {
    try {
      // Split the Base64 string to get the content type and the actual data
      const [header, base64Data] = base64String.split(',');
      const mimeType = header.match(/:(.*?);/)[1];

      // Decode Base64 to binary data
      const binaryData = atob(base64Data);
      const arrayBuffer = new Uint8Array(binaryData.length);

      for (let i = 0; i < binaryData.length; i++) {
        arrayBuffer[i] = binaryData.charCodeAt(i);
      }

      // Create a Blob from the binary data
      const blob = new Blob([arrayBuffer], { type: mimeType });

      // Convert Blob to File object
      return new File([blob], filename, { type: mimeType });
    } catch (error) {
      console.error("Error in base64ToFile:", error.message);
      throw error;
    }
  }


  // Get all variables from all fields
  async function collectVariable(allField) {
    let tempAllVariables = [];

    // Regular expression to match text inside square brackets, ensuring it has content
    allField.map((elt) => {
      // Check if elt is a string and use match to find matches inside square brackets
      if (typeof elt === 'string') {
        let matches = elt.match(/\[([^\]]+)\]/g);  // Modified to capture the content inside square brackets
        if (matches) {
          matches.forEach(item => tempAllVariables.push(item.replace(/\[|\]/g, '')));  // Append matched variables
        }
      }
    });

    // Return the array of matched variables without brackets
    return tempAllVariables;
  }

  async function collectVariablesFromSuggestions(suggestions) {
    let suggestionVariables = []; // To store all matched variables

    // Iterate over the suggestions array
    suggestions.forEach((elt) => {
      // Iterate over each key of the object
      for (let key in elt) {
        if (elt[key] && typeof elt[key] === "string") {  // Check if the value is a string
          let matches = elt[key].match(/\[([^\]]+)\]/g);  // Match content inside square brackets
          if (matches) {
            matches.forEach(item => suggestionVariables.push(item.replace(/\[|\]/g, '')));
          }
        }
      }
    });

    // Return the collected variables as a string without brackets
    // console.log('suggestionVariables: ', suggestionVariables);
    return suggestionVariables;
  }


  const convertImageToBase64 = (imageUrl) => {
    return new Promise((resolve, reject) => {
      const img = new Image();
      img.crossOrigin = "Anonymous"; // Needed for cross-origin images
      img.src = imageUrl;

      img.onload = () => {
        const canvas = document.createElement("canvas");
        canvas.width = img.width;
        canvas.height = img.height;

        const ctx = canvas.getContext("2d");
        ctx.drawImage(img, 0, 0);

        // Get the Base64 string
        const base64 = canvas.toDataURL("image/png"); // You can specify the format (e.g., 'image/png', 'image/jpeg')
        resolve(base64);
      };

      img.onerror = (error) => {
        reject(error);
      };
    });
  };



  async function submitForApproval() {
    try {

      if (isCategory === "rich_card") {
        // Loader start
        setLoading(true)
        // console.log('ddd1111')

        // Perform validation
        let suggestion = suggestions[isCategory];
        // console.log('suggestion_rich_card1111: ', suggestion);
        const isRichCardValid = await richCardValidation();

        if (!isRichCardValid) {

          return;
        }
        if (isRichCardValid) {
          const isSuggestionValid = await suggestionValidation(suggestion);
          if (!isSuggestionValid) {
            // Loader stop

            return;
          }
        }
        let tempMeidaHeight = ""
        let tempHorizPosition = ""
        if (RcAloneOrientation === "VERTICAL") {
          tempMeidaHeight = mediaHeight
        } else if (RcAloneOrientation === "HORIZONTAL") {
          tempHorizPosition = horizontalPosition
        }

        // thumbnail image
        let thumbnail_src = thumbnailRef.current.src
        // console.log('thumbnail_src: ', thumbnail_src);
        let fileObject = await base64ToFile(thumbnail_src, 'thumbnail.jpg');
        let uploadedFileType = rcaFileUrl.type.slice(0, rcaFileUrl.type.lastIndexOf('/'))
        let thumbnail = ""
        if (uploadedFileType === "video") {
          thumbnail = fileObject
        }

        // console.log('rcaFileUrl: ', rcaFileUrl.size);


        // get variables from all fields
        let allField = [cardTitle, CardTitleDes]
        let collectVariableData1 = await collectVariable(allField)
        // console.log('collectVariableData1: ', collectVariableData1);

        let collectVariableData2 = await collectVariablesFromSuggestions(suggestion.suggestion)
        // console.log('collectVariableData2: ', collectVariableData2);
        let allVariables = [...collectVariableData1, ...collectVariableData2]
        // console.log('allVariables____________: ', allVariables);

        // console.log('_rcaFileUrl:_ ', rcaFileUrl);

        let mediaFileTest_scr = mediaFileTestRef.current.src
        let base64mediaFileTest_scr = await convertImageToBase64(mediaFileTest_scr)
        // console.log('base64mediaFileTest_scr: ', base64mediaFileTest_scr);
        let textImage = await base64ToFile(base64mediaFileTest_scr, 'mediFile.png');
        // console.log('textImage: ', textImage);

        const formData = new FormData();
        formData.append('templateName', templateName1);
        formData.append('category', isCategory);
        formData.append('cardOrientation', RcAloneOrientation);
        formData.append('mediaHeight', tempMeidaHeight);
        formData.append('horizontalPosition', tempHorizPosition);
        formData.append('rcaFileUrl', rcaFileUrl);
        // formData.append('rcaFileUrl', textImage);
        formData.append('cardTitle', cardTitle);
        formData.append('cardTitleDescription', CardTitleDes);
        formData.append('suggestions', JSON.stringify(suggestion.suggestion));
        formData.append('thumbnail', thumbnail);
        formData.append('all_variables', JSON.stringify(allVariables));

        const response = await apiCall({
          endpoint: 'templates/savetemplate_richcardalone',
          method: 'POST',
          payload: formData,
        });

        // Handle the response
        if (response.success) {
          alert('Rich Card saved successfully!');

          // Reset Template Fields
          resetTemplateFields()
        }

      }
      else if (isCategory === "carousel") {
        // Loader start
        setLoading(true)

        let suggestion = suggestions[isCategory].card_suggestion;
        let cardsData = cards;

        // console.log('cardsData:', cardsData);
        // console.log('suggestion:', suggestion);

        // video exist status
        let isVideoExist = false

        let card_suggestion_Data = cardsData.map((card) => {
          const { dataurl, ...restCard } = card; // Exclude `dataurl` from card
          const matchingSuggestion = suggestion.find(
            (item) => item.card_number === card.id
          );

          // check media type video or not
          if (card?.image) {
            let mediaType = card.image.type.slice(0, card.image.type.lastIndexOf('/'))
            // console.log('mediaType_: ', mediaType);
            if (mediaType === "video" && !isVideoExist) {
              isVideoExist = true
            }
          }


          return {
            ...restCard, // Spread all properties except `dataurl`
            suggestion: matchingSuggestion ? matchingSuggestion.suggestion : []
          };
        });


        // thumbnail image
        let thumbnail = ""

        if (isVideoExist) {
          let thumbnail_src = thumbnailCarouselRef.current.src
          thumbnail = await base64ToFile(thumbnail_src, 'thumbnail.jpg');
          // console.log('thumbnail____: ', thumbnail);
        }

        // const card_suggestion_Data = await Promise.all(
        //   cardsData.map(async(card) => {
        //     const { dataurl, ...restCard } = card; // Exclude dataurl from card
        //     const matchingSuggestion = suggestion.find(
        //       (item) => item.card_number === card.id
        //     );

        //     let thumbnail= ""
        //     // thumbnail image        

        //       let mediaType= card.image.type.slice(0, card.image.type.lastIndexOf('/'))
        //       console.log('mediaType_: ', mediaType);
        //       if(mediaType === "video"){
        //         try {
        //           // thumbnail image
        //           let thumbnail_src = thumbnailRef.current.src
        //           thumbnail = await base64ToFile(thumbnail_src, "thumbnail.jpg");
        //           console.log("Generated thumbnail file: ", thumbnail);
        //         } catch (error) {
        //           console.error("Error generating thumbnail file:", error);
        //         }

        //       }



        //     return {
        //       ...restCard, // Spread all properties except dataurl
        //       thumbnail: thumbnail,
        //       suggestion: matchingSuggestion ? matchingSuggestion.suggestion : []
        //     };
        //   })
        // )



        if (!templateName1) {
          alert("Please Fill Template Name")

          return;
        }


        if (templateName1) {
          let cardSuggestionsValid = await validateCardSuggestions(card_suggestion_Data, selectedCardId);

          if (!cardSuggestionsValid) {

            return
          }
        }

        // console.log('card_suggestion_Data____: ', card_suggestion_Data);

        let cardTitleAndDesp = [];

        await Promise.all(
          card_suggestion_Data.map(async (elt) => {
            // Get variables from suggestions
            const suggestionVariables = await collectVariablesFromSuggestions(elt.suggestion);

            // Add the title, description, and suggestion variables directly to the array
            cardTitleAndDesp.push(elt.title, elt.description, ...suggestionVariables);
          })
        );

        // console.log(cardTitleAndDesp);

        let collectVariableData1 = []
        // get variables from all fields
        collectVariableData1 = await collectVariable(cardTitleAndDesp)
        // console.log('collectVariableData1: ', collectVariableData1);

        let collectVariableData2 = []

        await Promise.all(
          card_suggestion_Data.map(async (elt) => {
            collectVariableData2.push(await collectVariablesFromSuggestions(elt.suggestion))
          })
        )
        // console.log('collectVariableData2: ', collectVariableData2);

        let allVariables = [...collectVariableData1, ...collectVariableData2.flat()]
        // console.log('allVariables: ', allVariables);
        const formData = new FormData();
        formData.append('templateName', templateName1);
        formData.append('category', isCategory);
        formData.append('cardWidth', cardWidth);
        formData.append('mediaHeight', mediaHeight1);
        formData.append('card_suggestion_Data', JSON.stringify(card_suggestion_Data));

        cardsData.forEach(card => {
          if (card.image) {
            // Use card ID in the file name to maintain relationship
            const modifiedFileName = `card-${card.id}_${card.image.name}`;
            formData.append('images', card.image, modifiedFileName);
          }
        });
        formData.append('thumbnail', thumbnail);
        formData.append('all_variables', JSON.stringify(allVariables));

        // formData.append('cardWidth', cardWidth);
        // formData.append('mediaHeight', mediaHeight1);
        // formData.append('rcaFileUrl', rcaFileUrl);
        // formData.append('cardTitle', );
        // formData.append('cardTitleDescription', );
        // formData.append('suggestions', JSON.stringify(suggestion.suggestion));

        const response = await apiCall({
          endpoint: 'templates/savetemplate_richcardalone',
          method: 'POST',
          payload: formData,
        });

        // Handle the response        
        if (response.success) {
          alert(response.msg);

          // Reset Template Fields
          resetTemplateFields()
        }

      }
      else if (isCategory === "text_message") {
        // Loader start
        setLoading(true)
        let suggestion = suggestions[isCategory];
        // console.log('suggestion: ', suggestion);        
        const istextMessageValid = await textMessageValidation();

        if (!istextMessageValid) {

          return;
        }
        if (istextMessageValid) {
          const isSuggestionValid = await suggestionValidation(suggestion);
          if (!isSuggestionValid) {

            return;
          }
        }

        // get variables from all fields
        let allField = [CardTitleDes2]
        // console.log('allField: ', allField);
        let collectVariableData1 = await collectVariable(allField)
        // console.log('collectVariableData1: ', collectVariableData1);

        let collectVariableData2 = await collectVariablesFromSuggestions(suggestion.suggestion)
        // console.log('collectVariableData2: ', collectVariableData2);
        let allVariables = [...collectVariableData1, ...collectVariableData2]
        // console.log('allVariables____________: ', allVariables);

        const formData = new FormData();
        formData.append('templateName', templateName1);
        formData.append('category', isCategory);
        formData.append('cardTitleDescription', CardTitleDes2);
        formData.append('suggestions', JSON.stringify(suggestion.suggestion));
        formData.append('all_variables', JSON.stringify(allVariables));

        const response = await apiCall({
          endpoint: 'templates/savetemplate_richcardalone',
          method: 'POST',
          payload: formData,
        });

        // Handle the response
        if (response.success) {
          alert(response.msg);

          // Reset Template Fields
          resetTemplateFields()
        }

      }
      else if (isCategory === "text_message_with_pdf") {
        // Loader start
        setLoading(true)

        let suggestion = suggestions[isCategory];
        // console.log('suggestion: ', suggestion);        
        const istextMessagePdfValid = await textMessagePdfValidation();

        if (!istextMessagePdfValid) {

          return;
        }
        if (istextMessagePdfValid) {
          const isSuggestionValid = await suggestionValidation(suggestion);
          if (!isSuggestionValid) {

            return;
          }
        }
        // console.log("rcaFileUrl_pdf:", rcaFileUrl);

        // get variables from all fields
        let allField = [CardTitleDes3]
        let collectVariableData1 = await collectVariable(allField)

        let collectVariableData2 = await collectVariablesFromSuggestions(suggestion.suggestion)
        let allVariables = [...collectVariableData1, ...collectVariableData2]
        // console.log('allVariables____________: ', allVariables);

        const formData = new FormData();
        formData.append('templateName', templateName1);
        formData.append('category', isCategory);
        formData.append('rcaFileUrl', rcaFileUrl);
        formData.append('cardTitleDescription', CardTitleDes3);
        formData.append('pdf_position', rediopdf);
        formData.append('suggestions', JSON.stringify(suggestion.suggestion));
        formData.append('all_variables', JSON.stringify(allVariables));

        let response = await apiCall({
          endpoint: 'templates/savetemplate_richcardalone',
          method: 'POST',
          payload: formData,
        });

        // Handle the response        
        if (response) {
          alert(response.msg);

          // Reset Template Fields
          resetTemplateFields()
        }

      }

    } catch (err) {
      console.error('Error:', err);
      alert(err.response.data.msg || err.response.data.message || err || 'An error occurred. Please try again.');
    }
    finally {
      // Loader stop
      setLoading(false)
    }
  }





  // Handle add variable in this 

  const handleAddsuggestionVariable = async (id, fieldName) => {
    const variableText = "[user_param]"; // The predefined variable

    if (isCategory === "carousel") {
      setSuggestions((prevSuggestions) => {
        const updatedCardSuggestions = prevSuggestions.carousel.card_suggestion.map((card) => {
          // Check if the card_number matches
          if (card.card_number === selectedCardId) {
            // Update the suggestion array in the matching card
            const updatedSuggestions = card.suggestion.map((suggestion) => {
              if (suggestion.id === id) {
                let fieldValLength = suggestion[fieldName].length
                let maxchar_sug = defineMaxCharLength(fieldName)
                let fieldAvailableLength = maxchar_sug - fieldValLength

                if (fieldAvailableLength >= variableText.length) {
                  return {
                    ...suggestion,
                    [fieldName]: suggestion[fieldName] + variableText, // Update the dynamic field
                  };
                }
              }
              return suggestion; // Return the suggestion unchanged if the id doesn't match
            });

            // Return the updated card with updated suggestions
            return {
              ...card,
              suggestion: updatedSuggestions,
            };
          }
          return card; // Return the card unchanged if the card_number doesn't match
        });

        // Return the updated state with modified card_suggestion
        return {
          ...prevSuggestions,
          [isCategory]: {
            ...prevSuggestions[isCategory],
            card_suggestion: updatedCardSuggestions, // Update the card_suggestion array
          },
        };
      });
    } else {
      setSuggestions((prevSuggestions) => {
        const updatedSuggestions = prevSuggestions[isCategory].suggestion.map((suggestion) => {
          if (suggestion.id === id) {
            // Update the specified field of the matching suggestion
            let fieldValLength = suggestion[fieldName].length
            let maxchar_sug = defineMaxCharLength(fieldName)
            let fieldAvailableLength = maxchar_sug - fieldValLength

            if (fieldAvailableLength >= variableText.length) {
              return {
                ...suggestion,
                [fieldName]: suggestion[fieldName] + variableText, // Update the dynamic field
              };
            } else {
              return suggestion;
            }
          }
          return suggestion; // Return the suggestion unchanged if the id doesn't match
        });


        // Return the updated state with the modified suggestions
        return {
          ...prevSuggestions,
          [isCategory]: {
            ...prevSuggestions[isCategory], // Preserve other fields in the category
            suggestion: updatedSuggestions, // Update the suggestion array
          },

        };
      });
    }
  };

  // Handle Label Change
  const handleLableChange = (suggestionId, event) => {
    const updatedSuggestions = suggestions.map((suggestion) => {
      if (suggestion.id === suggestionId) {
        suggestion.label = event.target.value;
      }
      return suggestion;
    });
    setSuggestions(updatedSuggestions);
  };


  // Handle Action Change
  const handleActionChange = (suggestionId, event) => {
    if (isCategory === "carousel") {

    } else {
      setSuggestions((prevSuggestions) => {
        // Filter the suggestions to find the one with the matching id
        const updatedSuggestions = prevSuggestions[isCategory].suggestion.map((suggestion) => {
          if (suggestion.id === suggestionId) {
            // Update the selectedAction field of the matching suggestion
            return {
              ...suggestion,
              selectedAction: event.target.value, // Update the selectedAction field
            };
          }
          return suggestion; // Return the suggestion unchanged if the id doesn't match
        });

        // Return the updated suggestions state
        return {
          ...prevSuggestions,
          [isCategory]: {
            ...prevSuggestions[isCategory], // Ensure the rest of the category is preserved
            suggestion: updatedSuggestions,  // Update the suggestions array
          },
        };
      });
    }

  };

  // Handle Suggestion Text Change
  const handleSuggestionTextChange = (suggestionId, event) => {
    if (isCategory === "carousel") {

    } else {
      setSuggestions((prevSuggestions) => {
        // Filter the suggestions to find the one with the matching id
        const updatedSuggestions = prevSuggestions[isCategory].suggestion.map((suggestion) => {
          if (suggestion.id === suggestionId) {
            // Update the selectedAction field of the matching suggestion
            return {
              ...suggestion,
              suggestionText: event.target.value, // Update the selectedAction field
            };
          }
          return suggestion; // Return the suggestion unchanged if the id doesn't match
        });

        // Return the updated suggestions state
        return {
          ...prevSuggestions,
          [isCategory]: {
            ...prevSuggestions[isCategory], // Ensure the rest of the category is preserved
            suggestion: updatedSuggestions,  // Update the suggestions array
          },
        };
      });
    }
  };

  // Handle Suggestion Postback Change
  const handleSuggestionPostbackChange = (suggestionId, event) => {
    if (isCategory === "carousel") {

    } else {
      setSuggestions((prevSuggestions) => {
        // Filter the suggestions to find the one with the matching id
        const updatedSuggestions = prevSuggestions[isCategory].suggestion.map((suggestion) => {
          if (suggestion.id === suggestionId) {
            // Update the selectedAction field of the matching suggestion
            return {
              ...suggestion,
              suggestionPostback: event.target.value, // Update the selectedAction field
            };
          }
          return suggestion; // Return the suggestion unchanged if the id doesn't match
        });

        // Return the updated suggestions state
        return {
          ...prevSuggestions,
          [isCategory]: {
            ...prevSuggestions[isCategory], // Ensure the rest of the category is preserved
            suggestion: updatedSuggestions,  // Update the suggestions array
          },
        };
      });
    }
  };

  // Handle URL Change
  const handleUrlChange = (suggestionId, event) => {
    if (isCategory === "carousel") {

    } else {
      setSuggestions((prevSuggestions) => {
        // Filter the suggestions to find the one with the matching id
        const updatedSuggestions = prevSuggestions[isCategory].suggestion.map((suggestion) => {
          if (suggestion.id === suggestionId) {
            // Update the selectedAction field of the matching suggestion
            return {
              ...suggestion,
              urlAction: event.target.value, // Update the selectedAction field
            };
          }
          return suggestion; // Return the suggestion unchanged if the id doesn't match
        });

        // Return the updated suggestions state
        return {
          ...prevSuggestions,
          [isCategory]: {
            ...prevSuggestions[isCategory], // Ensure the rest of the category is preserved
            suggestion: updatedSuggestions,  // Update the suggestions array
          },
        };
      });
    }

  };

  // Handle Phone Number Change
  const handlePhoneNumberChange = (suggestionId, event) => {
    if (isCategory === "carousel") {

    } else {
      setSuggestions((prevSuggestions) => {
        // Filter the suggestions to find the one with the matching id
        const updatedSuggestions = prevSuggestions[isCategory].suggestion.map((suggestion) => {
          if (suggestion.id === suggestionId) {
            // Update the selectedAction field of the matching suggestion
            return {
              ...suggestion,
              dialerAction: event.target.value, // Update the selectedAction field
            };
          }
          return suggestion; // Return the suggestion unchanged if the id doesn't match
        });

        // Return the updated suggestions state
        return {
          ...prevSuggestions,
          [isCategory]: {
            ...prevSuggestions[isCategory], // Ensure the rest of the category is preserved
            suggestion: updatedSuggestions,  // Update the suggestions array
          },
        };
      });
    }

  };

  // Handle Latitude Change
  const handleLatitudeChange = (suggestionId, event) => {
    if (isCategory === "carousel") {

    } else {
      setSuggestions((prevSuggestions) => {
        // Filter the suggestions to find the one with the matching id
        const updatedSuggestions = prevSuggestions[isCategory].suggestion.map((suggestion) => {
          if (suggestion.id === suggestionId) {
            // Update the selectedAction field of the matching suggestion
            return {
              ...suggestion,
              latitude: event.target.value, // Update the selectedAction field
            };
          }
          return suggestion; // Return the suggestion unchanged if the id doesn't match
        });

        // Return the updated suggestions state
        return {
          ...prevSuggestions,
          [isCategory]: {
            ...prevSuggestions[isCategory], // Ensure the rest of the category is preserved
            suggestion: updatedSuggestions,  // Update the suggestions array
          },
        };
      });
    }

  };

  // Handle Longitude Change
  const handleLongitudeChange = (suggestionId, event) => {
    if (isCategory === "carousel") {

    } else {
      setSuggestions((prevSuggestions) => {
        // Filter the suggestions to find the one with the matching id
        const updatedSuggestions = prevSuggestions[isCategory].suggestion.map((suggestion) => {
          if (suggestion.id === suggestionId) {
            // Update the selectedAction field of the matching suggestion
            return {
              ...suggestion,
              longitude: event.target.value, // Update the selectedAction field
            };
          }
          return suggestion; // Return the suggestion unchanged if the id doesn't match
        });

        // Return the updated suggestions state
        return {
          ...prevSuggestions,
          [isCategory]: {
            ...prevSuggestions[isCategory], // Ensure the rest of the category is preserved
            suggestion: updatedSuggestions,  // Update the suggestions array
          },
        };
      });
    }
  };

  // Handle Event Date Change
  const handleEventDateChange = (suggestionId, event) => {
    const updatedSuggestions = suggestions.map((suggestion) => {
      if (suggestion.id === suggestionId) {
        suggestion.eventDate = event.target.value;
      }
      return suggestion;
    });
    setSuggestions(updatedSuggestions);
  };

  // Handle Event Title Change
  const handleEventTitleChange = (suggestionId, event) => {
    const updatedSuggestions = suggestions.map((suggestion) => {
      if (suggestion.id === suggestionId) {
        suggestion.eventTitle = event.target.value;
      }
      return suggestion;
    });
    setSuggestions(updatedSuggestions);
  };

  // Handle Event Description Change
  const handleEventDescriptionChange = (suggestionId, event) => {
    const updatedSuggestions = suggestions.map((suggestion) => {
      if (suggestion.id === suggestionId) {
        suggestion.eventDescription = event.target.value;
      }
      return suggestion;
    });
    setSuggestions(updatedSuggestions);
  };

  // Handle Remove Suggestion
  // const handleRemoveSuggestion = (suggestionId) => {
  //   const updatedSuggestions = suggestions.filter(
  //     (suggestion) => suggestion.id !== suggestionId
  //   );
  //   setSuggestions(updatedSuggestions);
  // };

  const defineMaxCharLength = (fieldName) => {

    let maxchar_sug // length as per fields
    if (fieldName === "suggestionText" || fieldName === "label") {
      maxchar_sug = maxchar25
    }
    else if (fieldName === "suggestionPostback") {
      maxchar_sug = maxchar120
    }
    // else if(fieldName === "urlAction"  ){
    //   maxchar_sug=maxChars
    // }
    // else if(fieldName === "dialerAction"){
    //   maxchar_sug=maxChar13
    // }
    else if (fieldName === "eventTitle" || fieldName === "eventDescription" || fieldName === "urlAction") {
      maxchar_sug = maxchar2048
    }

    return maxchar_sug
  }

  const handlePhoneNumberInput = (value) => {
    // Remove all spaces
    value = value.replace(/\s/g, '');

    // Check if starts with +91
    if (!value.startsWith('+91')) {
      value = '+91' + value.replace(/\D/g, '');
    }

    // Remove any non-digits after +91
    const prefix = value.slice(0, 3); // +91
    const numbers = value.slice(3).replace(/\D/g, '');

    // Limit to 10 digits after +91
    const limitedNumbers = numbers.slice(0, 10);

    return prefix + limitedNumbers;
  };


  const handleSuggestionField = (id, fieldName, fieldValue) => {
    if (isCategory === "carousel") {
      setSuggestions((prevSuggestions) => {
        const updatedCardSuggestions = prevSuggestions[isCategory].card_suggestion.map((card) => {
          // Check if the card_number matches
          if (card.card_number === selectedCardId) {
            // Update the suggestion array in the matching card
            const updatedSuggestions = card.suggestion.map((suggestion) => {
              if (suggestion.id === id) {

                // length as per fields
                let maxchar_sug = defineMaxCharLength(fieldName)

                if (fieldName === "selectedAction" || fieldName === "latitude" || fieldName === "longitude" || fieldName === "eventDateTime" || fieldName === "dialerAction") {
                  return {
                    ...suggestion,
                    [fieldName]: fieldValue, // Update the dynamic field
                  };

                }
                else {
                  if (fieldValue.length <= maxchar_sug) {
                    return {
                      ...suggestion,
                      [fieldName]: fieldValue, // Update the dynamic field
                    };
                  }
                }

              }
              return suggestion; // Return the suggestion unchanged if the id doesn't match
            });

            // Return the updated card with updated suggestions
            return {
              ...card,
              suggestion: updatedSuggestions,
            };
          }
          return card; // Return the card unchanged if the card_number doesn't match
        });

        // Return the updated state with modified card_suggestion
        return {
          ...prevSuggestions,
          [isCategory]: {
            ...prevSuggestions[isCategory],
            card_suggestion: updatedCardSuggestions, // Update the card_suggestion array
          },
        };
      });
    } else {

      setSuggestions((prevSuggestions) => {

        const updatedSuggestions = prevSuggestions[isCategory].suggestion.map((suggestion) => {
          if (suggestion.id === id) {


            // length as per fields
            let maxchar_sug = defineMaxCharLength(fieldName)

            if (fieldName === "selectedAction" || fieldName === "latitude" || fieldName === "longitude" || fieldName === "eventDateTime") {
              // console.log('fieldValue_111111111111111:', fieldValue)
              return {
                ...suggestion,
                [fieldName]: fieldValue, // Update the dynamic field
              };

            }
            else if (fieldName === "dialerAction") {
              fieldValue = handlePhoneNumberInput(fieldValue)
              // console.log('fieldValue: ', fieldValue);
              return {
                ...suggestion,
                [fieldName]: fieldValue, // Update the dynamic field
              };
            }
            else {
              if (fieldValue.length <= maxchar_sug) {

                // Update the specified field of the matching suggestion
                return {
                  ...suggestion,
                  [fieldName]: fieldValue, // Update the dynamic field
                };
              }
            }



          }
          return suggestion; // Return the suggestion unchanged if the id doesn't match
        });


        // Return the updated state with the modified suggestions
        return {
          ...prevSuggestions,
          [isCategory]: {
            ...prevSuggestions[isCategory], // Preserve other fields in the category
            suggestion: updatedSuggestions, // Update the suggestion array
          },

        };

      });
    }
  };


  const handleRemoveSuggestion = (id) => {

    // console.log('id://// ', id);

    if (isCategory === "carousel") {
      setSuggestions((prevSuggestions) => {
        let reindexedSuggestions;
        const updatedCardSuggestions = prevSuggestions[isCategory].card_suggestion.map((card) => {
          if (card.card_number === selectedCardId) {
            // Filter out the suggestion with the given id
            const filteredSuggestions = card.suggestion.filter((suggestion) => suggestion.id !== id);

            // Reassign the IDs sequentially starting from 1 after filtering
            reindexedSuggestions = filteredSuggestions.map((suggestion, index) => ({
              ...suggestion,
              id: index + 1 // Assign the new ID based on the index
            }));

            return {
              ...card,
              suggestion: reindexedSuggestions, // Update the suggestions for this card
            };
          }
          return card; // Keep other cards unchanged
        });


        return {
          ...prevSuggestions,
          [isCategory]: {
            ...prevSuggestions[isCategory],
            card_suggestion: updatedCardSuggestions, // Update the card suggestions with the reindexed IDs
          },
        };
      });

      setNextId((prevId) => ({
        ...prevId,
        [isCategory]: prevId[isCategory].map((cardData) => {
          if (cardData.card_number === id) {
            return {
              ...cardData, // Spread the existing card data
              id: cardData.id - 1 // Decrement the id
            };
          }
          return cardData;
        })

      }));

    } else {
      setSuggestions((prevSuggestions) => {
        // Filter out the suggestion with the given id
        const filteredSuggestions = prevSuggestions[isCategory].suggestion.filter(
          (suggestion) => suggestion.id !== id
        );

        // Reassign the IDs sequentially starting from 1 after filtering
        const reindexedSuggestions = filteredSuggestions.map((suggestion, index) => ({
          ...suggestion,
          id: index + 1 // Assign the new ID based on the index
        }));

        return {
          ...prevSuggestions,
          [isCategory]: {
            ...prevSuggestions[isCategory],
            suggestion: reindexedSuggestions, // Update the suggestions with reindexed IDs
          },
        };
      });

      setNextId((prevId) => ({
        ...prevId,
        [isCategory]: prevId.id - 1
      }));

    }
  };


  //new functions end


  // const [suggestions, setSuggestions] = useState([])
  const [suggestions, setSuggestions] = useState({
    rich_card: {
      // template_type: isCategory,
      card_suggestion: [],
      suggestion: [],
    },
    carousel: {
      // template_type: isCategory,
      card_suggestion: [],
      suggestion: [],
    },
    text_message: {
      // template_type: isCategory,
      card_suggestion: [],
      suggestion: [],
    },
    text_message_with_pdf: {
      // template_type: isCategory,
      card_suggestion: [],
      suggestion: [],
    },
  });

  // useEffect(() => {
  //   setSuggestions(prevState => ({
  //     ...prevState,  // keep other categories intact
  //     rich_card: {
  //       ...prevState.rich_card,  
  //       template_type: isCategory,
  //     },
  //     carousel: {
  //       ...prevState.carousel,
  //       template_type: isCategory,
  //     },
  //     text_message: {
  //       ...prevState.text_message,
  //       template_type: isCategory,
  //     },
  //     text_message_with_pdf: {
  //       ...prevState.text_message_with_pdf,
  //       template_type: isCategory,
  //     },
  //   }));
  // }, [isCategory]);

  // // Handler to add a new suggestion
  // const handleAddSuggestion = () => {

  //   if (suggestions.length >= 4) {
  //     alert('You can only add up to 4 suggestions.');
  //     return; // Stop the function if there are already 4 suggestions
  //   }
  //   // Create a new suggestion object with default values
  //   const newSuggestion = {
  //     id: suggestions.length + 1, // New ID based on the current length
  //     selectedAction: 'Reply',
  //     suggestionText: '',
  //     suggestionPostback: '',
  //     urlAction: '',
  //     dialerAction: '',
  //     latitude: '',
  //     longitude: '',
  //     eventDateTime: '',
  //     eventTitle: '',
  //     eventDescription: '',
  //     label:''
  //   };

  //   // Add the new suggestion to the suggestions array
  //   setSuggestions([...suggestions, newSuggestion]);
  // };

  // const [suggestions, setSuggestions] = useState([
  //   {
  //     template_type: isCategory,
  //     card_suggestion: [],
  //     suggestion: [],
  //   }
  // ]);

  // Handler to add a new suggestion
  // const handleAddSuggestion = () => {
  //   // if (suggestions.length >= 4) {
  //   //   alert('You can only add up to 4 suggestions.');
  //   //   return; // Stop the function if there are already 4 suggestions
  //   // }

  //   let newSuggestion

  //   if(isCategory==="carousel"){
  //     newSuggestion = [
  //       {
  //         template_type: isCategory,
  //         card_suggestion: [
  //           {
  //             card_number: selectedCardId,
  //             suggestion: [
  //               { 
  //                 id: nextId, // Use the current nextId
  //                 selectedAction: 'Reply',
  //                 suggestionText: '',
  //                 suggestionPostback: '',
  //                 urlAction: '',
  //                 dialerAction: '',
  //                 latitude: '',
  //                 longitude: '',
  //                 eventDateTime: '',
  //                 eventTitle: '',
  //                 eventDescription: '',
  //                 label: ''
  //               }
  //             ],
  //           },

  //         ],
  //         suggestion: [],
  //       }
  //     ];  
  //   }
  //   else{
  //     newSuggestion = [
  //       {
  //         template_type: isCategory,
  //         card_suggestion: [],
  //         suggestion: [
  //           { 
  //             id: nextId, // Use the current nextId
  //             selectedAction: 'Reply',
  //             suggestionText: '',
  //             suggestionPostback: '',
  //             urlAction: '',
  //             dialerAction: '',
  //             latitude: '',
  //             longitude: '',
  //             eventDateTime: '',
  //             eventTitle: '',
  //             eventDescription: '',
  //             label: ''
  //           },

  //         ],
  //       }
  //     ];
  //   }

  //   // Add the new suggestion to the suggestions array
  //   setSuggestions(prevSuggestions => [...prevSuggestions, newSuggestion]);
  //   console.log('suggestions11111:', suggestions)
  //   // Increment the nextId for the next suggestion
  //   setNextId(prevId => prevId + 1);
  // };
  const handleAddSuggestion = () => {
    // Create a shallow copy of the current suggestions state
    const updatedSuggestions = { ...suggestions };

    // Handle "carousel" category
    if (isCategory === "carousel") {
      const existingCardIndex = updatedSuggestions[isCategory].card_suggestion.findIndex(
        (card) => card.card_number === selectedCardId
      );
      // console.log('existingCardIndex: ', existingCardIndex);
      // console.log("nextId:........", nextId)
      // console.log("nextId:........", nextId[isCategory])
      // Check if we can add a suggestion
      if (existingCardIndex !== -1) {
        // console.log('existingCardIndex22222: ', existingCardIndex);

        // Card suggestion already exists, check the length
        if (updatedSuggestions[isCategory].card_suggestion[existingCardIndex].suggestion.length < 4) {
          // console.log('1a')
          updatedSuggestions[isCategory].card_suggestion[existingCardIndex].suggestion.push({
            id: nextId[isCategory].find((item) => item.card_number === selectedCardId)?.id,
            selectedAction: "Reply",
            suggestionText: "",
            suggestionPostback: "",
            urlAction: "",
            dialerAction: "",
            latitude: "",
            longitude: "",
            eventDateTime: "",
            eventTitle: "",
            eventDescription: "",
            label: "",
          });




          setSuggestions((prevSuggestions) => ({
            ...prevSuggestions,
            [isCategory]: {
              ...prevSuggestions[isCategory],
              card_suggestion: updatedSuggestions[isCategory].card_suggestion
            }

          }))
          // Increment the nextId for the next suggestion
          setNextId((prevId) => ({
            ...prevId,
            [isCategory]: prevId[isCategory].map((item) =>
              item.card_number === selectedCardId ? { ...item, id: item.id + 1 } : item
            )
          }));


        } else {
          alert("You cannot add no more than 4 suggestions.");
        }
      } else {
        // Add a new card suggestion
        if (updatedSuggestions[isCategory].card_suggestion.length < 4) {
          // console.log('1b')
          // console.log('id_id...', nextId[isCategory])
          updatedSuggestions[isCategory].card_suggestion.push({
            card_number: selectedCardId,
            suggestion: [
              {
                id: nextId[isCategory].find((item) => item.card_number === selectedCardId)?.id,
                selectedAction: "Reply",
                suggestionText: "",
                suggestionPostback: "",
                urlAction: "",
                dialerAction: "",
                latitude: "",
                longitude: "",
                eventDateTime: "",
                eventTitle: "",
                eventDescription: "",
                label: "",
              },
            ],
          });


          setSuggestions((prevSuggestions) => ({
            ...prevSuggestions,
            [isCategory]: {
              ...prevSuggestions[isCategory],
              card_suggestion: updatedSuggestions[isCategory].card_suggestion
            }

          }))
          // Increment the nextId for the next suggestion
          setNextId((prevId) => ({
            ...prevId,
            [isCategory]: prevId[isCategory].map((item) =>
              item.card_number === selectedCardId ? { ...item, id: item.id + 1 } : item
            )
          }));


        } else {
          alert("You cannot add no more than 4 suggestions.");
        }


      }
    } else {
      // Handle non-carousel categories (e.g., "text_message", "text_message_with_pdf")
      if (isCategory === "rich_card") {
        if (updatedSuggestions[isCategory].suggestion.length < 4) {
          updatedSuggestions[isCategory].suggestion.push({
            id: nextId[isCategory].id,
            selectedAction: "Reply",
            suggestionText: "",
            suggestionPostback: "",
            urlAction: "",
            dialerAction: "",
            latitude: "",
            longitude: "",
            eventDateTime: "",
            eventTitle: "",
            eventDescription: "",
            label: "",
          });


          setSuggestions((prevSuggestions) => ({
            ...prevSuggestions,
            [isCategory]: {
              ...prevSuggestions[isCategory],
              suggestion: updatedSuggestions[isCategory].suggestion
            }

          }))
          // Increment the nextId for the next suggestion
          setNextId((prevId) => ({
            ...prevId,
            [isCategory]: {
              ...prevId[isCategory],
              id: prevId[isCategory].id + 1
            }
          }));


        } else {
          alert("You cannot add no more than 4 suggestions.");
        }
      }
      else {
        if (updatedSuggestions[isCategory].suggestion.length < 11) {
          updatedSuggestions[isCategory].suggestion.push({
            id: nextId[isCategory].id,
            selectedAction: "Reply",
            suggestionText: "",
            suggestionPostback: "",
            urlAction: "",
            dialerAction: "",
            latitude: "",
            longitude: "",
            eventDateTime: "",
            eventTitle: "",
            eventDescription: "",
            label: "",
          });


          setSuggestions((prevSuggestions) => ({
            ...prevSuggestions,
            [isCategory]: {
              ...prevSuggestions[isCategory],
              suggestion: updatedSuggestions[isCategory].suggestion
            }

          }))
          // Increment the nextId for the next suggestion
          setNextId((prevId) => ({
            ...prevId,
            [isCategory]: {
              ...prevId[isCategory],
              id: prevId[isCategory].id + 1
            }
          }));


        } else {
          alert("You cannot add no more than 11 suggestions.");
        }
      }
    }





    // console.log("Updated suggestions:", updatedSuggestions);
  };







  // nikhil suggestion work end 

  const handleInputChangenew = (e) => {
    const value = e.target.value.trim();
    if (value.length <= maxChars) {
      setTemplateName1(value);
    }
  };

  const handleInputChangeCards = (e) => {
    const value = e.target.value;
    if (value.length <= maxChars3) {
      setCardTitle(value);
    }
  };
  const handleInputChangeCardDes = (e) => {
    const value = e.target.value;
    if (value.length <= maxChars2) {
      setCardTitleDes(value);
    }
  };
  const handleInputChangeCardDes1 = (e) => {
    const value = e.target.value;
    if (value.length <= maxChars4) {
      setCardTitleDes1(value);
    }
  };
  const handleInputChangeCardDes2 = (e) => {
    const value = e.target.value;
    if (value.length <= maxChars5) {
      setCardTitleDes2(value);
    }
  };

  const handleInputChangeCardDes3 = (e) => {
    const value = e.target.value;
    if (value.length <= maxChars6) {
      setCardTitleDes3(value);
    }
  };


  // // new condition add for crop image
  // const handleFileChange = (event) => {
  //   const file = event.target.files[0];
  //   if (file) {
  //     setSelectedFile(URL.createObjectURL(file));
  //     setSelectedFileName(file.name);
  //     // setrcaFileUrl(file)

  //   }
  //   if (file) {
  //     const reader = new FileReader();
  //     reader.onload = () => {
  //       setImageSrc(reader.result);
  //       setFileName(file.name.split(".")[0]);
  //       initializeCropper(reader.result);
  //     };
  //     reader.readAsDataURL(file);
  //   }



  // };

  const mediaFileSize = (maxFileInMB) => {
    let mediaMaxFileSize = maxFileInMB * 1024 * 1024;
    return mediaMaxFileSize
  }

  const handleFileChange = (event) => {
    try {
      // loader start
      setLoading(true)
      const file = event.target.files[0];
      if (file) {
        // console.log('file_: ', file);
        const fileType = file.type;
        // console.log('fileType: ', fileType);
        let imgFileSizeInMB = 2
        let videoFileSizeInMB = 10
        if (isCategory === "carousel") {
          imgFileSizeInMB = 1
          videoFileSizeInMB = 5
        }

        // Check if the file is an image
        if (fileType.startsWith("image/")) {
          // only less than 2mb image allwoed
          // 1,048,576 bytes= 1MB
          if (file.size <= mediaFileSize(imgFileSizeInMB)) {
            // Set the selected image URL for display
            setSelectedFile(URL.createObjectURL(file));  // Object URL for image preview
            setSelectedFileName(file.name);  // Store the original file name

            // Read the image file as Data URL to load it into the cropper
            const reader = new FileReader();
            reader.onload = () => {
              setImageSrc(reader.result);  // Set the image source for cropping
              setFileName(file.name.split(".")[0]);  // Set file name without extension
              initializeCropper(reader.result);  // Initialize the cropper with the image data
            };
            reader.readAsDataURL(file);  // Read the file as Data URL for Cropper
          } else {
            alert(`Image size should be less than ${imgFileSizeInMB}MB`);
          }
        }

        // Check if the file is a video
        else if (fileType.startsWith("video/")) {
          // only less than 10mb video allwoed
          if (file.size <= mediaFileSize(videoFileSizeInMB)) {
            // For video, just create an object URL and display the video URL
            const videoURL = URL.createObjectURL(file);
            setSelectedFile(videoURL);  // Set the video URL for display
            setSelectedFileName(file.name);  // Store the original file name
            setFileName(file.name.split(".")[0]);  // Set file name without extension
            setVedioData(videoURL);  // Store the video URL in state to use in your input field
            setImageSrc(videoURL)
            // Optional: You can further handle videos (e.g., playing or showing thumbnails)
          } else {
            alert(`Video size should be less than ${videoFileSizeInMB}MB`);
          }
        }
        else {
          // Handle unsupported file types
          alert("Unsupported file type selected.");
        }
      }
    } catch (error) {
      throw error
    } finally {
      // loader stop
      setLoading(false)
    }
  };







  const handleFileChangevedioimage = async (event) => {
    try {
      // loader start
      setLoading(true)

      const inputValue = event.target.value;
      setVedioDataurlname(inputValue)
      setFileURL(inputValue);
      if (!inputValue) {
        return;
      }

      // Check if the input is a valid URL
      if (inputValue.startsWith('http') || inputValue.startsWith('https')) {
        try {


          const isImage = mediaType  // Check for image file extensions
          const isVideo = mediaType  // Check for video file extensions


          if (isImage == 'image') {
            try {

              // console.log('hitttimage');
              const response = await fetch(inputValue);

              const blob = await response.blob();
              const file = new File([blob], "image-from-url.jpg", { type: blob.type });

              if (file.size <= mediaFileSize(2)) {
                // Now we have a file-like object, use URL.createObjectURL to display it
                const fileURL = URL.createObjectURL(file);

                // Set the state with the URL and file data
                setVedioDataurl(event.target.value);
                setFileURL(event.target.value);
                // Initialize the cropper with the file URL (if required)
                initializeCropper(fileURL);  // Make sure initializeCropper is properly defined elsewhere
              } else {
                alert('Image size should be less than 2MB');
              }
            } catch (error) {
              alert('Please give valid URL');
              throw new Error('Failed to fetch the image');
            }


          } else if (isVideo === 'video') {
            try {

              // console.log('hitttimage');
              const response = await fetch(inputValue);

              const blob = await response.blob();
              const file = new File([blob], "image-from-url.jpg", { type: blob.type });

              if (file.size <= mediaFileSize(10)) {
                // console.log('hitttvideo');
                // It's a video, handle it by directly setting the URL
                setVedioData(inputValue)
                setVedioDataurl(event.target.value);
                setFileURL(event.target.value);
                setSelectedFileName("video-from-url.mp4"); // Set video name for identification
                setrcaFileUrl('video-from-url.mp4');
              } else {
                alert('Video size should be less than 10MB');
              }

            } catch (error) {
              alert('Please give valid URL');
              throw new Error('Failed to fetch the image');
            }

          } else {
            console.log("Unsupported URL type. Not an image or video.");
          }
        } catch (error) {
          console.error("Error fetching the media: ", error);
        }

      } else {
        console.log("Invalid URL provided");
      }

    } catch (error) {
      throw error
    }
    finally {
      // loader stop
      setLoading(false)
    }
  };






  const handleFileChangesecound = async (event) => {
    try {
      // loader start
      setLoading(true)

      const inputValue = event.target.value;
      setFileURL(inputValue);
      if (!inputValue) {
        console.log("No input URL provided");
        return;
      }

      // Check if the input is a valid URL
      if (inputValue.startsWith('http') || inputValue.startsWith('https')) {
        try {


          // Check if the URL is an image or video
          const isImage = inputValue.match(/\.(jpeg|jpg|gif|png)$/i);  // Check for image file extensions
          const isVideo = inputValue.match(/\.(mp4|mov|avi|webm)$/i);  // Check for video file extensions

          if (isImage) {
            try {
              // It's an image, fetch the image from the URL
              const response = await fetch(inputValue);

              const blob = await response.blob();
              const file = new File([blob], "image-from-url.jpg", { type: blob.type });
              // console.log('file_______: ', file);

              // only less than 2mb image allwoed
              if (file.size <= mediaFileSize(2)) {
                // Now we have a file-like object, use URL.createObjectURL to display it
                const fileURL = URL.createObjectURL(file);
                // console.log('fileURL_: ', fileURL);


                // Set the state with the URL and file data
                setFileURL(inputValue);
                setPreviewURL(fileURL);

                setSelectedFile(fileURL); // Set the temporary file URL
                setSelectedFileName(file.name); // Store the file name

                // Initialize the cropper with the file URL (if required)
                initializeCropper(fileURL);  // Make sure initializeCropper is properly defined elsewhere
              } else {
                alert('Image size should be less than 2MB');
              }
            } catch (error) {
              alert('Please give valid URL');
              throw new Error('Failed to fetch the image');
            }


          } else if (isVideo) {
            // console.log("bhitvideo SECTION");
            try {
              const response = await fetch(inputValue);

              // console.log('response__: ', response);


              const blob = await response.blob();
              const file = new File([blob], "video-from-url.mp4", { type: blob.type });

              // only less than 10mb video allwoed
              if (file.size <= mediaFileSize(10)) {

                // console.log("bhitvideo SECTION");
                // It's a video, handle it by directly setting the URL



                setFileURL(inputValue);

                setPreviewURL(inputValue);

                setSelectedFile(inputValue);
                setSelectedFileName("video-from-url.mp4"); // Set video name for identification
                setrcaFileUrl('video-from-url.mp4');

                setVedioData(inputValue)
                // console.log('setPreviewURL:111111111111 ', previewURL);


              } else {
                alert('Video size should be less than 10MB');
              }

            } catch (error) {
              // console.log('error: ', error);
              alert('Please give valid URL');
              throw new Error('Failed to fetch the video');
            }

          } else {
            console.log("Unsupported URL type. Not an image or video.");
          }
        } catch (error) {
          console.error("Error fetching the media: ", error);
        }
      } else {
        console.log("Invalid URL provided");
      }
    } catch (error) {
      throw error
    } finally {
      // loader stop
      setLoading(false)
    }
  };

  // Sample video player initialization function


  const handleFileChangesecoundcrousel = async (event, cardId) => {
    const inputValue = event.target.value;

    if (!inputValue) {
      console.log("No input URL provided");
      return;
    }

    // Check if the input is a valid URL
    if (inputValue.startsWith('http') || inputValue.startsWith('https')) {
      try {
        // Check if the URL is an image or video
        const isImage = inputValue.match(/\.(jpeg|jpg|gif|png)$/i);  // Check for image file extensions
        const isVideo = inputValue.match(/\.(mp4|mov|avi|webm)$/i);  // Check for video file extensions

        if (isImage) {
          // It's an image, fetch the image from the URL
          const response = await fetch(inputValue);
          if (!response.ok) {
            throw new Error('Failed to fetch the image');
          }

          const blob = await response.blob();
          const file = new File([blob], "image-from-url.jpg", { type: blob.type });

          // Now we have a file-like object, use URL.createObjectURL to display it
          const fileURL = URL.createObjectURL(file);
          initializeCropper(fileURL);  // Make sure initializeCropper is properly defined elsewhere
          setPreviewSrc(fileURL);  // Display the image from the URL
          // Update the image state with the Blob URL
          setCards(prevCards =>
            prevCards.map(card =>
              card.id === cardId.id
                ? { ...card, image: file, dataurl: fileURL, mediaType: 'image' }  // Set the Blob URL for the correct card
                : card
            )
          );





        } else if (isVideo) {
          // It's a video, handle it by directly setting the URL

          // Update the image state with the Blob URL
          setCards(prevCards =>
            prevCards.map(card =>
              card.id === cardId.id
                ? { ...card, image: file, dataurl: fileURL, mediaType: 'video' }  // Set the Blob URL for the correct card
                : card
            )
          );


        } else {
          console.log("Unsupported URL type. Not an image or video.");
        }
      } catch (error) {
        console.error("Error fetching the media: ", error);
      }
    } else {
      console.log("Invalid URL provided");
    }
  };








  const handleFileChange1 = (event) => {
    // console.log('hittt');
    const file = event.target.files[0];
    if (file) {
      setSelectedFile1(URL.createObjectURL(file));
      setSelectedFileName1(file.name);

    }
  }








  const handleOrientationChange = (event) => {
    setOrientation(event.target.value);
  };
  const handleUpload = () => {
    console.log("File uploaded with RcAloneOrientation:", RcAloneOrientation);
    if (activeTab === "image") {
      console.log("Uploaded file:", selectedFile);
    } else if (activeTab === "url" || activeTab === "videoUrl") {
      console.log("Uploaded URL:", fileURL);
    }
    setShowModal(false);
  };




  const handleUploadpdf = (event) => {

    const file = event.target.files[0];
    // console.log('file: ', file);

    if (file) {
      setSelectedFile(URL.createObjectURL(file));  // Display the selected image URL
      setSelectedFileName(file.name);  // Store the original file name

      setrcaFileUrl(file)
      // Read the image file as Data URL to load it into the cropper
      const reader = new FileReader();
      reader.onload = () => {

        setFileName(file.name.split(".")[0]);  // Set file name without extension

      };
      reader.readAsDataURL(file);  // Read the file as Data URL for Cropper
    }

  }


  const handleUploadpdf1111 = () => {
    // console.log('hittt');
    // console.log(pdffileicon, 'pdffileiconpdffileicon1111');
    setPreviewSrc(pdffileicon)

    setShowModalpdf(false)


  }







  // const handleAddSuggestion = () => {
  //   const newSuggestion = {
  //     id: Date.now(),
  //     title: "Suggested Action Title",
  //   };
  //   setSuggestions([...suggestions, newSuggestion]);

  // };
  // const handleRemoveSuggestion = (id) => {
  //   setSuggestions(suggestions.filter((suggestion) => suggestion.id !== id));
  // };
  // const handleActionChange = (event) => {
  //   setSelectedAction(event.target.value);
  // };

  const carouselRef = useRef(null);
  const [cards, setCards] = useState([
    { id: 1, title: "", description: "", image: null, dataurl: null, mediaType: null },
    { id: 2, title: "", description: "", image: null, dataurl: null, mediaType: null },
  ]);



  const handleFileChangecrousel = async (event, cardId) => {


    // Check if VedioData (canvas) is available
    if (VedioData) {

      // console.log('ok report',VedioData);
      const canvas = VedioData;  // Get the cropped canvas from VedioData
      if (canvas) {
        const croppedImageUrl = canvas;  // Convert canvas to Data URL (base64)
        // console.log('croppedImageUrl from VedioData: ', croppedImageUrl);

        // Dynamically update the image for the correct card based on cardId

        // Convert Data URL to File object (for backend or further usage)
        dataURLToFile(croppedImageUrl, selectedFileName)
          .then((file) => {
            if (file) {
              // console.log('File created successfully:', file);

              // Convert file to Blob URL for displaying the image in the frontend
              const fileUrl = URL.createObjectURL(file);
              // fileUrl=JSON.stringify(fileUrl)
              // console.log('fileUrl_set: ', fileUrl);

              // Update the image state with the Blob URL
              setCards(prevCards =>
                prevCards.map(card =>
                  card.id === cardId.id
                    ? { ...card, image: file, dataurl: fileUrl, mediaType: 'video' }  // Set the Blob URL for the correct card
                    : card
                )
              );
              setVedioData("")
              setShowModal(false);  // Optionally close the modal
            } else {
              console.error('Error creating file');
            }
          })
          .catch((error) => {
            console.error('Error converting data URL to file:', error);
          });
      }
    }

    // Handle cropperInstance if available (for cropping)
    if (cropperInstance) {
      const canvas = cropperInstance.getCroppedCanvas({
        width: 960,
        height: 720
      });

      if (canvas) {
        const croppedImageUrl = canvas.toDataURL();  // Get the base64 URL of the cropped image
        // console.log('croppedImageUrl from cropperInstance: ', croppedImageUrl);

        // Dynamically update the image for the correct cardId
        setCards(prevCards =>
          prevCards.map(card =>
            card.id === cardId.id
              ? { ...card, image: croppedImageUrl }  // Set the cropped image URL
              : card
          )
        );

        // Convert Data URL to File object (for backend or further usage)
        let file = ""
        file = await dataURLToFile(croppedImageUrl, selectedFileName);  // Create file from Data URL
        // Compress file size (file, fileSize)
        // file = await compressImage(file, 1)

        const fileUrl = URL.createObjectURL(file);  // Convert file to Blob URL




        // Update the image state with the Blob URL
        setCards(prevCards =>
          prevCards.map(card =>
            card.id === cardId.id
              ? { ...card, image: file, dataurl: croppedImageUrl, mediaType: 'image' }  // Set the Blob URL for the correct card
              : card
          )
        );

        // console.log(cards,'ksdbujsdvahscs1111111');

        setShowModal(false);  // Optionally close the modal
      }
    }
  };







  useEffect(() => {
    if (cards.length > 0 && selectedCardId === null) {
      setSelectedCardId(cards[0].id);
    }
  }, [cards, selectedCardId]);

  const addCard = async () => {
    if (cards.length >= 10) {
      alert("You cannot add more than 10 cards.");
      return;
    }
    // console.log('cards111: ', cards);

    const newCard = {
      id: cards.length + 1,
      title: "",
      description: "",
      image: null,
      isActive: false,
    };

    setCards((prevCards) => {
      const updatedCards = [...prevCards, newCard];
      // console.log("Updated cards in setState:", updatedCards);
      return updatedCards;
    });

    const addNextID = {
      card_number: cards.length + 1,
      id: 1
    }

    // Update the nextId state
    setNextId((prevNextId) => {
      const updatedNextIdState = {
        ...prevNextId,
        [isCategory]: [...prevNextId[isCategory], addNextID]
      };
      console.log("Updated nextId in setState:", updatedNextIdState);
      return updatedNextIdState;
    });



    // console.log("enter");

    // console.log("cards after adding: ", cards);
    // console.log('nextId.....................: ', nextId);

  };

  // useEffect(() => {
  //   console.log("Cards updated:", cards);
  // }, [cards]);

  // useEffect(() => {
  //   console.log("NextId updated:", nextId);
  // }, [nextId]);



  const handleRemoveCard = (id) => {
    setCards((prevCards) => {

      let filterCards = prevCards.filter((card) => card.id !== id)

      let reIndexCards = filterCards.map((card, index) => ({
        ...card,
        id: index + 1,
      }))

      return reIndexCards
    });

    if (selectedCardId === id) {
      setSelectedCardId(1);
    }
  };

  const handleCardClick = (id) => {


    setSelectedCardId(id);

    const newid = id - 1



    if (cards[newid].image == null || '') {
      setSelectedFileName('')
      setrcaFileUrl('')
      setPreviewURL('')
      setImageSrc('')

    } else {
      setPreviewURL(cards[newid].dataurl)
      setImageSrc(cards[newid].dataurl)
      setSelectedFileName(cards[newid].image.name)
      setrcaFileUrl(cards[newid].dataurl)



    }


  };

  const handleInputChangeCard = (field, value) => {
    const charLength =
      field === "title" ? maxChars3 :
        field === "description" ? maxChars2 : 0

    if (["title", "description"].includes(field) && selectedCardId !== null) {
      setCards((prevCards) =>
        prevCards.map((card) => {
          if (card.id === selectedCardId) {

            if (value.length <= charLength) {
              return { ...card, [field]: value }
            }
            return card
          }
          return card
        })
      );
    }
  };

  const selectedCard =
    selectedCardId !== null
      ? cards.find((card) => card.id === selectedCardId)
      : null;

  // console.log('isCategory:', isCategory)

  // const addCard = () => {
  //   const newCard = {
  //     id: cards.length + 1,
  //     content: `Card ${cards.length + 1}`,
  //     isActive: false,
  //   };
  //   setCards([...cards, newCard]);
  // };


  const removeCard = (id) => {
    const updatedCards = cards.filter((card) => card.id !== id);
    const renumberedCards = updatedCards.map((card, index) => ({
      ...card,
      content: `Card ${index + 1}`,
      id: index + 1,
    }));
    setCards(renumberedCards);
  };

  const toggleActive = (id) => {
    setCards(cards.map((card) => ({
      ...card,
      isActive: card.id === id ? !card.isActive : false,
    })));
  };

  const scrollLeft = () => {
    if (carouselRef.current) {
      carouselRef.current.scrollLeft -= 200;
    } else {
      console.error("carouselRef.current is null");
    }
  };

  const scrollRight = () => {
    if (carouselRef.current) {
      carouselRef.current.scrollLeft += 200;
    } else {
      console.error("carouselRef.current is null");
    }
  };
  const handleAddVariable = () => {
    if (CardTitleDes.length + variableText.length > maxChars2) {
      alert(`Cannot add variable. Maximum limit of ${maxChars2} characters reached.`);
      return;
    }
    const textarea = document.getElementById("CardTitleDes");
    if (!textarea) return;
    const start = textarea.selectionStart;
    const end = textarea.selectionEnd;

    const newText =
      CardTitleDes.slice(0, start) + "[user_param]" + CardTitleDes.slice(end);

    setCardTitleDes(newText);
    setTimeout(() => {
      textarea.selectionStart = start + "[user_param]".length;
      textarea.selectionEnd = start + "[user_param]".length;
    }, 0);
  };
  const handleAddVariable1 = () => {
    if (cardTitle.length + variableText.length > maxChars1) {
      alert(`Cannot add variable. Maximum limit of ${maxChars1} characters reached.`);
      return;
    }
    const textarea = document.getElementById("cardTitle");
    if (!textarea) return;
    const start = textarea.selectionStart;
    const end = textarea.selectionEnd;

    const newText =
      cardTitle.slice(0, start) + "[user_param]" + cardTitle.slice(end);

    setCardTitle(newText);
    setTimeout(() => {
      textarea.selectionStart = start + "[user_param]".length;
      textarea.selectionEnd = start + "[user_param]".length;
    }, 0);
  };
  // const handleAddVariable2 = () => {
  //   if (cardTitle1.length + variableText.length > maxChars3) {
  //     alert(`Cannot add variable. Maximum limit of ${maxChars3} characters reached.`);
  //     return;
  //   }
  //   const textarea = document.getElementById("cardTitle1");
  //   if (!textarea) return;
  //   const start = textarea.selectionStart;
  //   const end = textarea.selectionEnd;

  //   const newText =
  //     cardTitle1.slice(0, start) + "[user_param]" + cardTitle1.slice(end);

  //   setCardTitle1(newText);
  //   setTimeout(() => {
  //     textarea.selectionStart = start + "[user_param]".length;
  //     textarea.selectionEnd = start + "[user_param]".length;
  //   }, 0);
  // };

  const handleAddVariable2 = (field) => {
    const charLength =
      field === "title" ? maxChars3 :
        field === "description" ? maxChars2 : 0
    let variableText = "[user_param]"

    if (["title", "description"].includes(field) && selectedCardId !== null) {
      setCards((prevCards) =>
        prevCards.map((card) => {
          if (card.id === selectedCardId) {

            let updatedVal = card[field] + variableText

            if (updatedVal.length <= charLength) {
              return { ...card, [field]: updatedVal }
            } else {
              alert(`Cannot add variable. Maximum limit of ${charLength} characters reached.`)
            }
            return card
          }
          return card
        })
      );
    }
  };

  const handleAddVariable3 = () => {
    if (CardTitleDes1.length + variableText.length > maxChars4) {
      alert(`Cannot add variable. Maximum limit of ${maxChars4} characters reached.`);
      return;
    }
    const textarea = document.getElementById("CardTitleDes1");
    if (!textarea) return;
    const start = textarea.selectionStart;
    const end = textarea.selectionEnd;

    const newText =
      CardTitleDes1.slice(0, start) + "[user_param]" + CardTitleDes1.slice(end);

    setCardTitleDes1(newText);
    setTimeout(() => {
      textarea.selectionStart = start + "[user_param]".length;
      textarea.selectionEnd = start + "[user_param]".length;
    }, 0);
  };
  const handleAddVariable4 = () => {
    if (CardTitleDes2.length + variableText.length > maxChars5) {
      alert(`Cannot add variable. Maximum limit of ${maxChars5} characters reached.`);
      return;
    }
    const textarea = document.getElementById("CardTitleDes2");
    if (!textarea) return;
    const start = textarea.selectionStart;
    const end = textarea.selectionEnd;

    const newText =
      CardTitleDes2.slice(0, start) + "[user_param]" + CardTitleDes2.slice(end);

    setCardTitleDes2(newText);
    setTimeout(() => {
      textarea.selectionStart = start + "[user_param]".length;
      textarea.selectionEnd = start + "[user_param]".length;
    }, 0);
  };
  const handleAddVariable5 = () => {
    if (CardTitleDes3.length + variableText.length > maxChars6) {
      alert(`Cannot add variable. Maximum limit of ${maxChars6} characters reached.`);
      return;
    }
    const textarea = document.getElementById("CardTitleDes3");
    if (!textarea) return;
    const start = textarea.selectionStart;
    const end = textarea.selectionEnd;

    const newText =
      CardTitleDes3.slice(0, start) + "[user_param]" + CardTitleDes3.slice(end);

    setCardTitleDes3(newText);
    setTimeout(() => {
      textarea.selectionStart = start + "[user_param]".length;
      textarea.selectionEnd = start + "[user_param]".length;
    }, 0);
  };


  // console.log('suggestions_Original:', suggestions)

  return (
    <>
      <div className="WB_add_template_contain">
        <h4 className="Head_title">Add Template</h4>
        <div className="WB_add_template_contain_body">
          <h1 className="title_header_b">
            Bot message type:
            <span> Promotional </span>
            <div className="info-icon">
              <div className="tooltip">
                Sales, marketing, or promotional messages to new or existing
                customers, about new or existing services or products with the
                intention to sell, cross-sell, or up-sell now or in the future.
                (Similar to the Promotional message category used for SMS in
                India).
              </div>
            </div>
            <p className="title_p_para">
              As your bot is of type ‘Promotional’, please ensure that you create
              a template of the same type. For details, hover on the ‘Info’ icon
              above.
            </p>
          </h1>

          <div className="row">
            <div className="col-lg-7">
              <div className="row gy-3">
                <div className="col-lg-12 col-12 mt-0">
                  <div className="form_group tem_title_head">
                    <label htmlFor="tname">
                      Template Name <span className="required_icon">*</span>
                      <p className="tem_para_temName">
                        Give your message template a name e.g., AccountUpdate,
                        OTP, etc., in 2-3 words. Only alphanumeric characters and
                        underscores are allowed. Spaces/other special characters
                        are not allowed.
                      </p>
                    </label>
                    <input
                      type="text"
                      id="tname"
                      placeholder="Enter Template Name"
                      onChange={handleInputChangenew}
                      value={templateName1}
                    />
                    <div className="chars_msg">
                      {templateName1.length}/{maxChars} chars used
                    </div>
                  </div>
                </div>
                <div className="col-lg-12 col-12">
                  <div className="form_group">
                    <label htmlFor="Category">
                      Template Type <span className="required_icon">*</span>
                      <p className="tem_para_temName">
                        Choose what type of message template you want to create
                      </p>
                    </label>
                    <select
                      id="Category"
                      value={isCategory}
                      onChange={(e) => setIsCategory(e.target.value)}
                    >
                      <option value="rich_card">Rich Card Stand Alone</option>
                      <option value="carousel">Rich Card Carousel</option>
                      <option value="text_message">Text Message</option>
                      <option value="text_message_with_pdf">
                        Text Message with PDF
                      </option>
                    </select>
                  </div>
                </div>
                <div className="col-lg-12 col-12 mt-3">
                  {isCategory === "rich_card" && (
                    <div className="rich_card_div">
                      <div className="col-lg-12 col-12">
                        <div className="form_group">
                          <label htmlFor="Orientation">
                            Select Card Orientation{" "}
                            <span className="required_icon">*</span>{" "}
                            <div className="info-icon">
                              <div className="tooltip tooltip1">
                                Please refer to the following link to know about Rich Card and Carousel Card attributes: <br />
                                <a
                                  className="link_a"
                                  href="https://developers.google.com/business-communications/rcs-business-messaging/guides/build/messages/send?hl=en#rich-cards"
                                  target="_blank"
                                  rel="noopener noreferrer"
                                >
                                  https://developers.google.com/business-communications/rcs-business-messaging/guides/build/messages/send?hl=en#rich-cards
                                </a>
                              </div>
                            </div>
                          </label>
                          <select
                            onChange={handleSelectChange}
                            value={RcAloneOrientation}
                          >
                            <option disabled>
                              Select
                            </option>
                            <option value="HORIZONTAL">HORIZONTAL</option>
                            <option value="VERTICAL">VERTICAL</option>
                          </select>
                        </div>
                      </div>

                      {/* Conditional Rendering for Dropdowns */}
                      {RcAloneOrientation === "VERTICAL" && (
                        <div className="col-lg-12 col-12">
                          <div className="form_group">
                            <label htmlFor="Height">
                              Select Media Height <span className="required_icon">*</span>{" "}
                              <div className="info-icon">
                                <div className="tooltip tooltip1">
                                  Please refer to the following link to know about Rich Card and Carousel Card attributes: <br />
                                  <a
                                    className="link_a"
                                    href="https://developers.google.com/business-communications/rcs-business-messaging/guides/build/messages/send?hl=en#rich-cards"
                                    target="_blank"
                                    rel="noopener noreferrer"
                                  >
                                    https://developers.google.com/business-communications/rcs-business-messaging/guides/build/messages/send?hl=en#rich-cards
                                  </a>
                                </div>
                              </div>
                            </label>
                            <select
                              id="Height"
                              value={mediaHeight}
                              onChange={(e) => setMediaHeight(e.target.value)} // Updates mediaHeight state
                            >

                              <option value="SHORT_HEIGHT">SHORT</option>
                              <option value="MEDIUM_HEIGHT">MEDIUM</option>
                            </select>
                          </div>
                        </div>
                      )}

                      {RcAloneOrientation === "HORIZONTAL" && (
                        <div className="col-lg-12 col-12">
                          <div className="form_group">
                            <label htmlFor="HorizontalPosition">
                              Select Horizontal Position <span className="required_icon">*</span>{" "}
                              <div className="info-icon">
                                <div className="tooltip tooltip1">
                                  Please refer to the following link to know about Rich Card and Carousel Card attributes: <br />
                                  <a
                                    className="link_a"
                                    href="https://developers.google.com/business-communications/rcs-business-messaging/guides/build/messages/send?hl=en#rich-cards"
                                    target="_blank"
                                    rel="noopener noreferrer"
                                  >
                                    https://developers.google.com/business-communications/rcs-business-messaging/guides/build/messages/send?hl=en#rich-cards
                                  </a>
                                </div>
                              </div>
                            </label>
                            <select
                              id="HorizontalPosition"
                              value={horizontalPosition}
                              onChange={(e) => setHorizontalPosition(e.target.value)}
                            >
                              <option value="default" disabled>
                                Select
                              </option>
                              <option value="LEFT">LEFT</option>
                              <option value="RIGHT">RIGHT</option>
                            </select>
                          </div>
                        </div>
                      )}

                      <div className="col-lg-12 col-12">
                        <div className="form_group">
                          <label htmlFor="Height">
                            Image/Video <span className="required_icon">*</span>{" "}
                            <div className="info-icon">
                              <div className="tooltip tooltip2">
                                Upload the Rich Card image or video.
                              </div>
                            </div>
                          </label>

                          <div className="upload_btn_input">
                            {/* <input
                              type="text"
                              id="tname"
                              placeholder="Please Upload file"
                              style={{ flex: 1 }}
                              value={selectedFileName || ""}
                              disabled
                            /> */}
                            <input
                              type="text"
                              id="tname"
                              placeholder="Please Upload file"
                              style={{ flex: 1 }}
                              value={rcaFileUrl.name || ''}
                              disabled
                            />
                            <button
                              type="button"
                              className="upload_btn_input_button"

                              onClick={(RcAloneOrientation, HorizontalPosition, setMediaHeight) => setShowModal(true)}

                            >
                              Upload
                            </button>
                          </div>
                          {/* Modal */}
                          {showModal && (
                            <div className="modal-overlay">
                              <div className="modal-content modal-content_box">
                                {/* Tabs */}
                                <div className="modal-tabs">
                                  <button
                                    className={`tab-button image-tab ${activeTab === "image" ? "active" : ""}`}
                                    onClick={() => setActiveTab("image")}
                                  >
                                    Upload
                                  </button>
                                  <button
                                    className={`tab-button url-tab ${activeTab === "url" ? "active" : ""}`}
                                    onClick={() => setActiveTab("url")}
                                  >
                                    Upload from URL
                                  </button>
                                  <button
                                    className={`tab-button video-tab ${activeTab === "videoUrl" ? "active" : ""}`}
                                    onClick={() => setActiveTab("videoUrl")}
                                  >
                                    Variable Image/Video URL
                                  </button>
                                </div>


                                {/* Tab content */}
                                {activeTab === "image" && (
                                  <div className="tab-content">
                                    <p>The image you specify must be 3:1 aspect ratio, have a max file size of 2MB,
                                      have an optimal resolution of 1440 pixels x 480 pixels, and should be a JPEG,
                                      JPG, PNG, or GIF. If the image you select doesn’t meet these requirements, you’ll
                                      have the opportunity to edit it.
                                      If you are uploading a video, the max file size is 10MB.</p>
                                    <h3>Upload Image or Video</h3>

                                    {/* Clickable Upload */}
                                    <div
                                      className="upload-placeholder"
                                      onClick={() => document.getElementById("hiddenFileInput").click()}

                                    >
                                      {selectedFile
                                        ? "File selected! Click to re-upload"
                                        : "Click to upload an image or video"}
                                    </div>
                                    <input
                                      type="file"
                                      id="hiddenFileInput"
                                      accept="image/*,video/*"
                                      onChange={handleFileChange}
                                      style={{ display: "none" }}
                                      value=""
                                    />

                                    {selectedFile && (
                                      <div className="preview">
                                        <h4>Preview:</h4>
                                        {/* Check the type of the file and render accordingly */}
                                        {selectedFileName && selectedFileName.match(/\.(jpg|jpeg|png|gif)$/i) ? (
                                          // Display image preview
                                          <img className="preview_image_box" src={imageSrc} ref={imageRef} alt="Preview" />
                                        ) : selectedFileName && selectedFileName.match(/\.(mp4|webm|ogg)$/i) ? (
                                          // Display video preview
                                          <video className="preview_video_box" controls>
                                            <source src={imageSrc} type="video/mp4" className="preview-video" />
                                            Your browser does not support the video tag.
                                          </video>
                                        ) : (
                                          <p>Unsupported file type</p>
                                        )}
                                      </div>
                                    )}



                                  </div>
                                )}

                                {activeTab === "url" && (
                                  <div className="tab-content">
                                    <p>The image you specify must be 3:1 aspect ratio, have a max file size of 2MB, have an optimal resolution of 1440 pixels x 480 pixels, and should be a JPEG, JPG, PNG, or GIF, and be located at a publicly available URL. If the image you upload doesn’t meet these requirements, you’ll have the opportunity to edit it.</p>
                                    <h3>Enter Image/Video URL</h3>
                                    <input
                                      className="url_input_upload"
                                      type="text"
                                      placeholder="Enter URL"
                                      value={fileURL}

                                      onChange={handleFileChangesecound}

                                    />
                                    {previewURL && (
                                      <div className="preview_img">
                                        <h4>Preview:</h4>

                                        {(previewURL) ? (
                                          previewURL.match(/\.(.mp4||mp4|webm|ogg)$/i) ? (
                                            <video controls src={previewURL} className="preview-video"></video>
                                          ) : (
                                            <img src={previewURL} ref={imageRef} alt="Preview" className="preview-image" />
                                          )
                                        ) : (
                                          <p>Invalid URL or file type. Please enter a direct link to an image or video (e.g., ending in .jpg, .png).</p>
                                        )}
                                      </div>
                                    )}
                                  </div>
                                )}

                                {activeTab === "videoUrl" && (
                                  <div className="tab-content">
                                    <p>The image you specify must be 3:1 aspect ratio, have a max file size of 2MB, have an optimal resolution of 1440 pixels x 480 pixels, and should be a JPEG, JPG, PNG, or GIF.The image must be publicly available after the variable is replaced at run-time. If the image you upload doesn’t meet these requirements, it may appear cropped or distorted. If you are uploading a video, the max file size is 10MB.
                                      To include a variable in the URL, rename [custom_param] to the desired variable name for API passing.
                                      Ensure the base URL is added before appending variables as suffixes. For example, if the base URL is "https://sampleUrl.com/demos/", appending [event] will result in the full URL: "https://sampleUrl.com/demos/[event]</p>
                                    <h3>Enter Video URL</h3>
                                    <div className="modal-radio-group">
                                      <label className="radio-option">
                                        <input
                                          type="radio"
                                          className="imag_radio_btn"
                                          name="mediaType"
                                          value="image"
                                          checked={mediaType === "image"}
                                          onChange={() => setMediaType("image")}
                                        />
                                        Image
                                      </label>
                                      <label className="radio-option">
                                        <input
                                          type="radio"
                                          className="imag_radio_btn"
                                          name="mediaType"
                                          value="video"
                                          onChange={() => setMediaType("video")}
                                        />
                                        Video
                                      </label>
                                    </div>


                                    <input
                                      type="text"
                                      placeholder={`Enter ${mediaType === "video" ? "Video" : "Image"} URL`}
                                      value={VedioDataurlname}
                                      onChange={handleFileChangevedioimage}
                                      className="url_input_upload"
                                    />
                                    {VedioDataurl && (
                                      <div className="preview_img">
                                        <h4>Preview:</h4>
                                        {(VedioDataurl) ? (
                                          mediaType === "video" ? (
                                            <video controls src={VedioDataurl} className="preview-video"></video>
                                          ) : (
                                            <img src={VedioDataurl} ref={imageRef} alt="Preview22222222" className="preview-image" />
                                          )
                                        ) : (
                                          <p>Invalid URL or file type. Please enter a direct link to a valid image or video.</p>
                                        )}
                                      </div>
                                    )}
                                  </div>
                                )}

                                {/* Modal Actions */}
                                <div className="modal-actions">
                                  {/* <button type="button" className="select_upload_btn" onClick={handleUpload}>
                                  Select
                                </button> */}
                                  {(imageSrc || VedioDataurl || previewURL || selectedFile) && (
                                    <button id="preview" className="select_upload_btn" onClick={handlePreview}>
                                      Select
                                    </button>
                                  )}

                                  <button type="button" className="cancel_btn_1" onClick={() => setShowModal(false)}>
                                    Cancel
                                  </button>

                                </div>
                              </div>
                            </div>
                          )}

                        </div>
                      </div>

                      <div className="col-lg-12 col-12">
                        <div className="form_group card_t_title">
                          <label htmlFor="Height">
                            Card Title<span className="required_icon">*</span>{" "}
                            <div className="info-icon">
                              <div className="tooltip tooltip1 tooltip_v">
                                If you add a variable, you can change the name of the [custom_param]. For eg., you can change the name of [custom_param1] to [NAME], [custom_param2] to [AMOUNT] and so on. These placeholders will be replaced by the actual values provided while scheduling the campaign. The number of characters used that you see at the bottom of the text box assumes a custom_param length of 10 characters. Please note that the actual length can be determined only at the time of scheduling the campaign when the variables are replaced with the actual values passed in the target audience excel file.
                                Also note that the max number of characters supported is 200 for a Rich Card Title. If the actual message length exceeds these values after substituting the custom variables at the time of campaign execution, the application will throw an error via the bot webhook.
                              </div>
                            </div>
                          </label>
                          <input
                            type="text"
                            onChange={handleInputChangeCards}
                            value={cardTitle}
                            id="cardTitle"
                          />
                          <div className="chars_msg1">
                            {cardTitle.length}/( {maxChars1} ) chars used
                          </div>
                          <div className="chars_msg chars_msg_btn" onClick={handleAddVariable1}>
                            + Add Variable
                          </div>
                        </div>
                      </div>

                      <div className="col-lg-12 col-12 ">
                        <div className="form_group form_group_des">
                          <label htmlFor="Height">
                            Card Description<span className="required_icon">*</span>{" "}
                            <div className="info-icon">
                              <div className="tooltip tooltip1">
                                Please refer to the following link to know about Rich
                                Card and Carousel Card attributes: <br />
                                <a
                                  className="link_a"
                                  href="https://developers.google.com/business-communications/rcs-business-messaging/guides/build/messages/send?hl=en#rich-cards"
                                  target="_blank"
                                  rel="noopener noreferrer"
                                >
                                  https://developers.google.com/business-communications/rcs-business-messaging/guides/build/messages/send?hl=en#rich-cards
                                </a>
                              </div>
                            </div>
                          </label>
                          <textarea
                            type="text"
                            onChange={handleInputChangeCardDes}
                            value={CardTitleDes}
                            id="CardTitleDes"
                          />
                          <div className="chars_msg1">
                            {CardTitleDes.length}/( {maxChars2} ) chars used
                          </div>
                          <div className="chars_msg chars_msg_btn" onClick={handleAddVariable}>
                            + Add Variable
                          </div>
                        </div>
                      </div>
                    </div>
                  )}
                  {isCategory === "carousel" && (
                    <div className="carousel_div">
                      <div className="card-container">
                        {/* {cards.map((card) => (
                        <div
                          key={card.id}
                          className={`card_new ${card.isActive ? "active" : ""}`}
                          onClick={() => toggleActive(card.id)}
                        >
                          <span>{card.content}</span>
                          {card.id > 2 && (
                            <button
                              className="remove-button"
                              onClick={(e) => {
                                e.stopPropagation();
                                removeCard(card.id);
                              }}
                            >
                              ✖
                            </button>
                          )}
                        </div>
                      ))} */}
                        {cards.map((card) => (
                          <div
                            key={card.id}
                            onClick={() => handleCardClick(card.id)}
                            className={selectedCardId === card.id ? "card_new active" : "card_new"}>
                            Card {card.id}
                            {card.id > 2 && (
                              <button
                                className="remove-button"
                                onClick={(e) => {
                                  e.stopPropagation();
                                  handleRemoveCard(card.id);
                                }}

                              >
                                ✖
                              </button>
                            )}
                          </div>
                        ))}
                      </div>
                      <button className="add-button" onClick={addCard}>
                        +
                      </button>

                      {/* {selectedCard && ( */}
                      <div className="col-lg-12 col-12">
                        <div className="form_group">
                          <label htmlFor="Height1">
                            Select Card Width <span className="required_icon">*</span>{" "}
                            <div className="info-icon">
                              <div className="tooltip tooltip1">
                                Please refer to the following link to know about Rich Card and Carousel Card attributes: <br />
                                <a
                                  className="link_a"
                                  href="https://developers.google.com/business-communications/rcs-business-messaging/guides/build/messages/send?hl=en#rich-cards"
                                  target="_blank"
                                  rel="noopener noreferrer"
                                >
                                  https://developers.google.com/business-communications/rcs-business-messaging/guides/build/messages/send?hl=en#rich-cards
                                </a>
                              </div>
                            </div>
                          </label>
                          <select id="Height1"
                            // value={selectedCard.card_width}
                            value={cardWidth}
                            onChange={(e) => setCardWidth(e.target.value)}
                          // onChange={(e) => handleInputChangeCard("card_width", e.target.value)}
                          >
                            <option value="default" disabled>
                              Select
                            </option>
                            <option value="SMALL_WIDTH">SMALL</option>
                            <option value="MEDIUM_WIDTH">MEDIUM</option>
                          </select>
                        </div>
                      </div>

                      <div className="col-lg-12 col-12">
                        <div className="form_group">
                          <label htmlFor="Height2">
                            Select Media Height <span className="required_icon">*</span>{" "}
                            <div className="info-icon">
                              <div className="tooltip tooltip1">
                                Please refer to the following link to know about Rich Card and Carousel Card attributes: <br />
                                <a
                                  className="link_a"
                                  href="https://developers.google.com/business-communications/rcs-business-messaging/guides/build/messages/send?hl=en#rich-cards"
                                  target="_blank"
                                  rel="noopener noreferrer"
                                >
                                  https://developers.google.com/business-communications/rcs-business-messaging/guides/build/messages/send?hl=en#rich-cards
                                </a>
                              </div>
                            </div>
                          </label>
                          <select id="Height2"
                            // value={selectedCard.media_height}
                            value={mediaHeight1}
                            onChange={(e) => setMediaHeight1(e.target.value)}
                          // onChange={(e) => handleInputChangeCard("media_height", e.target.value)}
                          >

                            <option value="default" disabled>
                              Select
                            </option>
                            <option value="SHORT_HEIGHT">SHORT</option>
                            <option value="MEDIUM_HEIGHT">MEDIUM</option>
                          </select>
                        </div>
                      </div>

                      <div className="col-lg-12 col-12">
                        <div className="form_group">
                          <label htmlFor="image">
                            Image/Video <span className="required_icon">*</span>{" "}
                            <div className="info-icon">
                              <div className="tooltip tooltip2">
                                Upload the Rich Card image or video.
                              </div>
                            </div>
                          </label>

                          <div className="upload_btn_input">
                            <input
                              type="text"
                              id="tname"
                              placeholder="Please Upload file"
                              style={{ flex: 1 }}
                              value={selectedFileName || ""}
                              disabled
                            />
                            <button
                              type="button"
                              className="upload_btn_input_button"
                              onClick={() => setShowModal(true)}

                            >
                              Upload
                            </button>
                          </div>
                          {/* Modal */}
                          {showModal && (
                            <div className="modal-overlay">
                              <div className="modal-content modal-content_box">
                                {/* Tabs */}
                                {
                                  isCategory == "carousel" ? (
                                    // Only show the Upload tab for "carousel"
                                    <div className="modal-tabs">
                                      <button
                                        className={`tab-button image-tab ${activeTab === "image" ? "active" : ""}`}
                                        onClick={() => setActiveTab("image")}
                                      >
                                        Upload
                                      </button>
                                    </div>
                                  ) : (
                                    // Render full tabs for other categories
                                    <div className="modal-tabs">
                                      <button
                                        className={`tab-button image-tab ${activeTab === "image" ? "active" : ""}`}
                                        onClick={() => setActiveTab("image")}
                                      >
                                        Upload
                                      </button>
                                      <button
                                        className={`tab-button url-tab ${activeTab === "url" ? "active" : ""}`}
                                        onClick={() => setActiveTab("url")}
                                      >
                                        Upload from URL
                                      </button>
                                      <button
                                        className={`tab-button video-tab ${activeTab === "videoUrl" ? "active" : ""}`}
                                        onClick={() => setActiveTab("videoUrl")}
                                      >
                                        Variable Image/Video URL
                                      </button>
                                    </div>
                                  )
                                }


                                {/* Tab content */}
                                {activeTab === "image" && (
                                  <div className="tab-content">
                                    <p>The image you specify must be 5:4 aspect ratio, have a max file size of 1MB, have an optimal resolution of 960 pixels x 720 pixels, and should be a JPEG, JPG, PNG, or GIF. If the image you select doesn’t meet these requirements, you’ll have the opportunity to edit it. If you are uploading a video, the max file size is 5MB.</p>
                                    <h3>Upload Image or Video</h3>

                                    {/* Clickable Upload */}
                                    <div
                                      className="upload-placeholder"
                                      onClick={() => document.getElementById("hiddenFileInput").click()}

                                    >
                                      {selectedFile
                                        ? "File selected! Click to re-upload"
                                        : "Click to upload an image or video"}
                                    </div>
                                    <input
                                      type="file"
                                      id="hiddenFileInput"
                                      accept="image/*,video/*"
                                      onChange={handleFileChange}
                                      style={{ display: "none" }}
                                      value=""
                                    />

                                    {/* Preview Section */}
                                    {selectedFile && (
                                      <div className="preview">
                                        <h4>Preview:</h4>
                                        {/* Check the type of the file and render accordingly */}
                                        {selectedFileName && selectedFileName.match(/\.(jpg|jpeg|png|gif)$/i) ? (
                                          // Display image preview
                                          <img className="preview_image_box" src={selectedFile} ref={imageRef} alt="Preview" />
                                        ) : selectedFileName && selectedFileName.match(/\.(mp4|webm|ogg)$/i) ? (
                                          // Display video preview
                                          <video className="preview_video_box" controls>
                                            <source src={selectedFile} type="video/mp4" />
                                            Your browser does not support the video tag.
                                          </video>
                                        ) : (
                                          <p>Unsupported file type</p>
                                        )}
                                      </div>
                                    )}


                                  </div>
                                )}

                                {activeTab === "url" && (
                                  <div className="tab-content">
                                    <p>The image you specify must be 3:1 aspect ratio, have a max file size of 2MB, have an optimal resolution of 1440 pixels x 480 pixels, and should be a JPEG, JPG, PNG, or GIF, and be located at a publicly available URL. If the image you upload doesn’t meet these requirements, you’ll have the opportunity to edit it.</p>
                                    <h3>Enter Image/Video URL</h3>
                                    <input
                                      className="url_input_upload33"
                                      type="text"
                                      placeholder="Enter URL"
                                      value={fileURL}
                                      onChange={handleFileChangesecound}

                                    />


                                    {previewURL && (
                                      <div className="preview_img">
                                        <h4>Preview:</h4>

                                        {(previewURL) ? (
                                          previewURL.match(/\.(mp4|webm|ogg)$/i) ? (
                                            <video controls src={previewURL} className="preview-video"></video>
                                          ) : (
                                            <img src={previewURL} ref={imageRef} alt="Preview" className="preview-image" />
                                          )
                                        ) : (
                                          <p>Invalid URL or file type. Please enter a direct link to an image or video (e.g., ending in .jpg, .png).</p>
                                        )}
                                      </div>
                                    )}












                                  </div>
                                )}

                                {activeTab === "videoUrl" && (
                                  <div className="tab-content">
                                    <p>The image you specify must be 3:1 aspect ratio, have a max file size of 2MB, have an optimal resolution of 1440 pixels x 480 pixels, and should be a JPEG, JPG, PNG, or GIF.The image must be publicly available after the variable is replaced at run-time. If the image you upload doesn’t meet these requirements, it may appear cropped or distorted. If you are uploading a video, the max file size is 10MB.
                                      To include a variable in the URL, rename [custom_param] to the desired variable name for API passing.
                                      Ensure the base URL is added before appending variables as suffixes. For example, if the base URL is "https://sampleUrl.com/demos/", appending [event] will result in the full URL: "https://sampleUrl.com/demos/[event]</p>
                                    <h3>Enter Video URL</h3>
                                    <div className="modal-radio-group">
                                      <label className="radio-option">
                                        <input
                                          type="radio"
                                          className="imag_radio_btn"
                                          name="mediaType"
                                          value="image"
                                          checked={mediaType === "image"}
                                          onChange={() => setMediaType("image")}
                                        />
                                        Image
                                      </label>
                                      <label className="radio-option">
                                        <input
                                          type="radio"
                                          className="imag_radio_btn"
                                          name="mediaType"
                                          value="video"
                                          onChange={() => setMediaType("video")}
                                        />
                                        Video
                                      </label>
                                    </div>


                                    <input
                                      type="text"
                                      placeholder="Enter Video URL"
                                      value={fileURL}
                                      onChange={handleFileChangesecound}
                                      className="url_input_upload"
                                    />









                                    {selectedFile && (
                                      <div className="preview_img">
                                        <h4>Preview:</h4>
                                        {(selectedFile) ? (
                                          mediaType === "video" ? (
                                            <video controls src={imageSrc} className="preview-video"></video>
                                          ) : (
                                            <img id="image" src={imageSrc} ref={imageRef} alt="Source" />
                                          )
                                        ) : (
                                          <p>Invalid URL or file type. Please enter a direct link to a valid image or video.</p>
                                        )}
                                      </div>
                                    )}
                                  </div>
                                )}

                                {/* Modal Actions */}
                                <div className="modal-actions">
                                  <button type="button" className="select_upload_btn" onClick={(e) => handleFileChangecrousel(e, selectedCard)}>
                                    Select
                                  </button>
                                  <button type="button" className="cancel_btn_1" onClick={() => setShowModal(false)}>
                                    Cancel
                                  </button>

                                </div>
                              </div>
                            </div>
                          )}

                        </div>
                      </div>

                      <div className="col-lg-12 col-12">
                        <div className="form_group card_t_title">
                          <label htmlFor="Height">
                            Card Title<span className="required_icon">*</span>{" "}
                            <div className="info-icon">
                              <div className="tooltip tooltip1 tooltip_v">
                                If you add a variable, you can change the name of the [custom_param]. For eg., you can change the name of [custom_param1] to [NAME], [custom_param2] to [AMOUNT] and so on. These placeholders will be replaced by the actual values provided while scheduling the campaign. The number of characters used that you see at the bottom of the text box assumes a custom_param length of 10 characters. Please note that the actual length can be determined only at the time of scheduling the campaign when the variables are replaced with the actual values passed in the target audience excel file.
                                Also note that the max number of characters supported is 200 for a Rich Card Title. If the actual message length exceeds these values after substituting the custom variables at the time of campaign execution, the application will throw an error via the bot webhook.
                              </div>
                            </div>
                          </label>
                          <input
                            type="text"
                            onChange={(e) => handleInputChangeCard("title", e.target.value)}
                            value={selectedCard.title || ""}
                            id="cardTitle1"
                          />
                          <div className="chars_msg1">
                            {selectedCard.title.length}/( {maxChars3} ) chars used
                          </div>
                          <div className="chars_msg chars_msg_btn"
                            // onClick={handleAddVariable2}
                            onClick={() => handleAddVariable2("title")}
                          >
                            + Add Variable
                          </div>
                        </div>
                      </div>

                      <div className="col-lg-12 col-12 ">
                        <div className="form_group form_group_des">
                          <label htmlFor="Height">
                            Card Description<span className="required_icon">*</span>{" "}
                            <div className="info-icon">
                              <div className="tooltip tooltip1">
                                Please refer to the following link to know about Rich
                                Card and Carousel Card attributes: <br />
                                <a
                                  className="link_a"
                                  href="https://developers.google.com/business-communications/rcs-business-messaging/guides/build/messages/send?hl=en#rich-cards"
                                  target="_blank"
                                  rel="noopener noreferrer"
                                >
                                  https://developers.google.com/business-communications/rcs-business-messaging/guides/build/messages/send?hl=en#rich-cards
                                </a>
                              </div>
                            </div>
                          </label>
                          <textarea
                            type="text"
                            value={selectedCard.description || ""}
                            onChange={(e) => handleInputChangeCard("description", e.target.value)}
                            id="CardTitleDes1"
                          />
                          <div className="chars_msg1">
                            {selectedCard.description.length}/( {maxChars2} ) chars used
                          </div>
                          <div className="chars_msg chars_msg_btn" onClick={() => handleAddVariable2("description")}>
                            + Add Variable
                          </div>
                        </div>
                      </div>
                    </div>
                  )}
                  {isCategory === "text_message" && (
                    <div className="col-lg-12 col-12 ">
                      <div className="form_group form_group_des form_group_des1">
                        <label htmlFor="Height">
                          Message Content<span className="required_icon">*</span>{" "}
                          <div className="info-icon">
                            <div className="tooltip tooltip1">
                              Please refer to the following link to know about Rich
                              Card and Carousel Card attributes: <br />
                              <a
                                className="link_a"
                                href="https://developers.google.com/business-communications/rcs-business-messaging/guides/build/messages/send?hl=en#rich-cards"
                                target="_blank"
                                rel="noopener noreferrer"
                              >
                                https://developers.google.com/business-communications/rcs-business-messaging/guides/build/messages/send?hl=en#rich-cards
                              </a>
                            </div>
                          </div>
                        </label>
                        <textarea
                          type="text"
                          onChange={handleInputChangeCardDes2}
                          value={CardTitleDes2}
                          id="CardTitleDes2"
                        />
                        <div className="chars_msg1">
                          {CardTitleDes2.length}/( {maxChars5} ) chars used
                        </div>
                        <div className="chars_msg chars_msg_btn" onClick={handleAddVariable4}>
                          + Add Variable
                        </div>
                      </div>
                    </div>
                  )}
                  {isCategory === "text_message_with_pdf" && (
                    <div className="text_message_with_pdf_div">

                      <div className="col-lg-12 col-12 ">
                        <div className="form_group form_group_des form_group_des1">
                          <label htmlFor="Height">
                            Message body<span className="required_icon">*</span>{" "}
                          </label>

                          <div className="pdf_radio_btn_box">
                            <label className="radio_label">
                              <input
                                type="radio"
                                name="pdf"
                                className="pdf_radio_btn"
                                value="pdf_at_top"
                                onChange={rediobuttonforpdf}
                                checked={rediopdf === "pdf_at_top"}
                              />
                              PDF at Top
                            </label>

                            <label className="radio_label">
                              <input
                                type="radio"
                                className="pdf_radio_btn"
                                name="pdf"
                                // value="text_top"
                                // value="pdf_at_bottom"
                                value="text_message_at_top"
                                onChange={rediobuttonforpdf}
                                checked={rediopdf === "text_message_at_top"}
                              />
                              Text Message at Top
                            </label>

                          </div>

                        </div>
                      </div>

                      <div className="col-lg-12 col-12 ">
                        <div className="form_group form_group_des form_group_des1">
                          <label htmlFor="Height">
                            Message body<span className="required_icon">*</span>{" "}
                            <div className="info-icon">
                              <div className="tooltip tooltip1">
                                Please refer to the following link to know about Rich
                                Card and Carousel Card attributes: <br />
                                <a
                                  className="link_a"
                                  href="https://developers.google.com/business-communications/rcs-business-messaging/guides/build/messages/send?hl=en#rich-cards"
                                  target="_blank"
                                  rel="noopener noreferrer"
                                >
                                  https://developers.google.com/business-communications/rcs-business-messaging/guides/build/messages/send?hl=en#rich-cards
                                </a>
                              </div>
                            </div>
                          </label>
                          <textarea
                            type="text"
                            id="CardTitleDes3"
                            onChange={handleInputChangeCardDes3}
                            value={CardTitleDes3}
                          />
                          <div className="chars_msg1">
                            {CardTitleDes3.length}/( {maxChars6} ) chars used
                          </div>
                          <div className="chars_msg chars_msg_btn" onClick={handleAddVariable5}>
                            + Add Variable
                          </div>
                        </div>
                      </div>

                      <div className="col-lg-12 col-12">
                        <div className="form_group form_group_des">
                          <label htmlFor="Height">
                            Image/Video <span className="required_icon">*</span>{" "}
                            <div className="info-icon">
                              <div className="tooltip tooltip2">
                                Upload the Rich Card image or video.
                              </div>
                            </div>
                          </label>

                          <div className="upload_btn_input">
                            <input
                              type="text"
                              id="tname"
                              placeholder="Please Upload file"
                              style={{ flex: 1 }}
                              value={selectedFileName || ""
                              }
                              disabled
                            />
                            <button
                              type="button"
                              className="upload_btn_input_button"
                              onClick={() => setShowModalpdf(true)}

                            >
                              Upload
                            </button>
                          </div>
                          {/* Modal */}
                          {showModal && (
                            <div className="modal-overlay">
                              <div className="modal-content modal-content_box">
                                {/* Tabs */}

                                {
                                  isCategory == "carousel" ? (
                                    // Only show the Upload tab for "carousel"
                                    <div className="modal-tabs">
                                      <button
                                        className={`tab-button image-tab ${activeTab === "image" ? "active" : ""}`}
                                        onClick={() => setActiveTab("image")}
                                      >
                                        Upload
                                      </button>
                                    </div>
                                  ) : (
                                    // Render full tabs for other categories
                                    <div className="modal-tabs">
                                      <button
                                        className={`tab-button image-tab ${activeTab === "image" ? "active" : ""}`}
                                        onClick={() => setActiveTab("image")}
                                      >
                                        Upload
                                      </button>
                                      <button
                                        className={`tab-button url-tab ${activeTab === "url" ? "active" : ""}`}
                                        onClick={() => setActiveTab("url")}
                                      >
                                        Upload from URL
                                      </button>
                                      <button
                                        className={`tab-button video-tab ${activeTab === "videoUrl" ? "active" : ""}`}
                                        onClick={() => setActiveTab("videoUrl")}
                                      >
                                        Variable Image/Video URL
                                      </button>
                                    </div>
                                  )
                                }




                                {/* Tab content */}
                                {activeTab === "image" && (
                                  <div className="tab-content">
                                    <p>The image you specify must be 3:1 aspect ratio, have a max file size of 2MB,
                                      have an optimal resolution of 1440 pixels x 480 pixels, and should be a JPEG,
                                      JPG, PNG, or GIF. If the image you select doesn’t meet these requirements, you’ll
                                      have the opportunity to edit it.
                                      If you are uploading a video, the max file size is 10MB.</p>
                                    <h3>Upload Image or Video</h3>

                                    {/* Clickable Upload */}
                                    <div
                                      className="upload-placeholder"
                                      onClick={() => document.getElementById("hiddenFileInput").click()}

                                    >
                                      {selectedFile1
                                        ? "File selected! Click to re-upload"
                                        : "Click to upload an image or video"}
                                    </div>
                                    <input
                                      type="file"
                                      id="hiddenFileInput"
                                      accept="image/*,video/*"
                                      onChange={handleFileChange1}
                                      style={{ display: "none" }}
                                    />

                                    {/* Preview Section */}
                                    {selectedFile1 && (
                                      <div className="preview">
                                        <h4>Preview:</h4>
                                        <img className="preview_image_box"
                                          src={selectedFile1}
                                          alt="Preview"

                                        />
                                      </div>
                                    )}

                                  </div>
                                )}

                                {activeTab === "url" && (
                                  <div className="tab-content">
                                    <p>The image you specify must be 3:1 aspect ratio, have a max file size of 2MB, have an optimal resolution of 1440 pixels x 480 pixels, and should be a JPEG, JPG, PNG, or GIF, and be located at a publicly available URL. If the image you upload doesn’t meet these requirements, you’ll have the opportunity to edit it.</p>
                                    <h3>Enter Image/Video URL</h3>
                                    <input
                                      className="url_input_upload"
                                      type="text"
                                      placeholder="Enter URL"
                                      value={fileURL}
                                      onChange={(e) => setFileURL(e.target.value)}

                                    />
                                  </div>
                                )}

                                {activeTab === "videoUrl" && (
                                  <div className="tab-content">
                                    <p>The image you specify must be 3:1 aspect ratio, have a max file size of 2MB, have an optimal resolution of 1440 pixels x 480 pixels, and should be a JPEG, JPG, PNG, or GIF.The image must be publicly available after the variable is replaced at run-time. If the image you upload doesn’t meet these requirements, it may appear cropped or distorted. If you are uploading a video, the max file size is 10MB.
                                      To include a variable in the URL, rename [custom_param] to the desired variable name for API passing.
                                      Ensure the base URL is added before appending variables as suffixes. For example, if the base URL is "https://sampleUrl.com/demos/", appending [event] will result in the full URL: "https://sampleUrl.com/demos/[event]</p>
                                    <h3>Enter Video URL</h3>
                                    <div className="modal-radio-group">
                                      <label className="radio-option">
                                        <input
                                          type="radio"
                                          className="imag_radio_btn"
                                          name="mediaType"
                                          value="image"
                                          checked={mediaType === "image"}
                                          onChange={() => setMediaType("image")}
                                        />
                                        Image
                                      </label>
                                      <label className="radio-option">
                                        <input
                                          type="radio"
                                          className="imag_radio_btn"
                                          name="mediaType"
                                          value="video"
                                        />
                                        Video
                                      </label>
                                    </div>


                                    <input
                                      type="text"
                                      placeholder="Enter Video URL"
                                      value={fileURL}
                                      onChange={(e) => setFileURL(e.target.value)}
                                      className="url_input_upload"
                                    />
                                  </div>
                                )}

                                {/* Modal Actions */}
                                <div className="modal-actions">
                                  <button type="button" className="select_upload_btn" onClick={handleUpload}>
                                    Select
                                  </button>
                                  <button type="button" className="cancel_btn_1" onClick={() => setShowModal(false)}>
                                    Cancel
                                  </button>

                                </div>
                              </div>
                            </div>
                          )}





                          {showModalpdf &&
                            <div className="modal-overlay">
                              <div className="modal-content modal-content_box">
                                {/* Tabs */}
                                <div className="modal-tabs">
                                  <button
                                    className={`tab-button image-tab ${activeTab === "image" ? "active" : ""}`}
                                    onClick={() => setActiveTab("image")}
                                  >
                                    Upload
                                  </button>


                                </div>
                                <div>
                                  <input
                                    type="file"
                                    accept=".pdf"
                                    className="url_input_upload"
                                    onChange={handleUploadpdf}
                                  />
                                </div>




                                {/* Modal Actions */}
                                <div className="modal-actions">
                                  <button type="button" className="select_upload_btn" onClick={handleUploadpdf1111}>
                                    Select
                                  </button>
                                  <button type="button" className="cancel_btn_1" onClick={() => setShowModalpdf(false)}>
                                    Cancel
                                  </button>

                                </div>
                              </div>
                            </div>
                          }

                        </div>
                      </div>
                    </div>
                  )}
                </div>
              </div>
            </div>

            <div className="col-lg-5 mobile_display_box">
              <div className="mobile_border_box">
                <div className="tab-buttons">
                  <button
                    className={`tab-button screen_btn ${activeScreenTab === 'conversation' ? 'active' : ''}`}
                    onClick={() => setActiveScreenTab('conversation')}
                  >
                    Conversation
                  </button>
                  <button
                    className={`tab-button screen_btn ${activeScreenTab === 'businessInfo' ? 'active' : ''}`}
                    onClick={() => setActiveScreenTab('businessInfo')}
                  >
                    Business Info
                  </button>
                </div>



                <div className="Preview_Contain">

                  <div className="tab-content">
                    {activeScreenTab === 'conversation' && (
                      <div className="conversation-tab">
                        {isCategory === "rich_card" && (
                          <div>
                            {(selectedFile || cardTitle || CardTitleDes) && (
                              <div className="rich_card_preview_box_container">
                                <div className={`rich_card_preview_box ${RcAloneOrientation} ${horizontalPosition}`}>
                                  {/* {selectedFile && (
                                  <img src={selectedFile} className="box_image_preview" alt="Preview" />

                                  )} */}
                                  <div className="preview_img_content">
                                    {previewSrc ? (
                                      // Check if previewSrc is an image
                                      previewSrc.includes('image') ? (
                                        <img id="preview-image" src={previewSrc} alt="Preview" />
                                      ) : (
                                        // If it's not an image, render a video element
                                        <video id="preview-video" src={previewSrc} controls>
                                          Your browser does not support the video tag.
                                        </video>
                                      )
                                    ) : (
                                      <p>No preview available</p> // Fallback if previewSrc is empty
                                    )}
                                  </div>


                                  <div className="preview_content">
                                    <h4 className="card_title_n">{cardTitle}</h4>
                                    <p className="card_description_n">{CardTitleDes}</p>


                                    {suggestions[isCategory].suggestion.map((suggestion) => (
                                      <div className="card_description_new" key={suggestion.id} >

                                        <p className="card_description_n">
                                          {suggestion.suggestionText}
                                        </p>

                                      </div>
                                    ))}


                                  </div>



                                </div>
                              </div>
                            )}
                          </div>
                        )}
                        {isCategory === "carousel" && (
                          <div className="preview-carousel">
                            <button className="carousel-nav left" onClick={scrollLeft}>
                              &lt;
                            </button>
                            <div className="carousel-wrapper" ref={(el) => {
                              carouselRef.current = el;
                            }}>

                              {cards.map((card) => (
                                <div className="carousel_item" key={card.id}>
                                  {card.image && (
                                    <>
                                      {card.mediaType === 'image' ? (
                                        <img src={card.dataurl} alt={`Card ${card.id}`} />
                                      ) : card.mediaType === 'video' ? (
                                        <video className="preview-video" src={card.dataurl} controls />
                                      ) : (
                                        <p>No media uploaded</p>
                                      )}
                                    </>
                                  )}

                                  <h3>{card.title || `Card ${card.id}`}</h3>
                                  <p>{card.description}</p>
                                </div>
                              ))}






                            </div>
                            <button className="carousel-nav right" onClick={scrollRight}>
                              &gt;
                            </button>
                          </div>
                        )}
                        {isCategory === "text_message" && (
                          <div>
                            {(CardTitleDes2) && (
                              <div className={`rich_card_preview_box_container`}>
                                <div className="rich_card_preview_box">
                                  <p className="card_description_n">{CardTitleDes2}</p>
                                </div>
                              </div>
                            )}
                          </div>
                        )}
                        {isCategory === "text_message_with_pdf" && (
                          <div>
                            {(previewSrc || CardTitleDes3) && (
                              <div className="rich_card_preview_box_container">
                                <div className={`rich_card_preview_box ${rediopdf}`}>
                                  {previewSrc && (
                                    <img src={pdffileicon} className={`box_image_preview box_image_preview_pdf ${rediopdf} `} alt="Preview" />
                                  )}
                                  <p className="card_description_n">{CardTitleDes3}</p>
                                </div>
                              </div>
                            )}
                          </div>
                        )}

                      </div>
                    )}
                    {activeScreenTab === 'businessInfo' && (
                      <div className="business-info-tab">
                        <img src={easygobanner} alt="banner image" />


                        <div className="business_info_logo">
                          <img src={easygologo} alt="logo image" />
                        </div>
                        <div className="main-desc">
                          <h4>EASYGOSMS</h4>
                          <p>EASYGOSMS INDIA PVT LTD is the top notch <br /> leading Bulk SMS services <br />  provider across globe.</p>
                        </div>

                        <div className="social_icons">
                          <a href="tel:+919821867344">
                            <div className="icon_group">
                              <img src={call} alt="call logo" />
                              Call
                            </div>
                          </a>
                          <a href="https://www.easygosms.com/" target="_blank">
                            <div className="icon_group">
                              <img src={internet} alt="internet logo" />
                              Website
                            </div>
                          </a>
                          <a href="mailto:support@easygosms.com">
                            <div className="icon_group">
                              <img src={email} alt="email logo" />
                              Email
                            </div>
                          </a>
                        </div>
                        <div className="tab-header">
                          <button
                            className={`tab-btn ${selectedTab === 'infoTab' ? 'active' : ''}`}
                            onClick={() => setSelectedTab('infoTab')}
                          >
                            Info
                          </button>
                          <button
                            className={`tab-btn ${selectedTab === 'optionsTab' ? 'active' : ''}`}
                            onClick={() => setSelectedTab('optionsTab')}
                          >
                            Options
                          </button>
                        </div>
                        <div className="tab-content">
                          {selectedTab === 'infoTab' && (
                            <div className="info-tab-content">
                              <div className="icon_content">
                                <img src={call1} alt="call logo" />
                                <div className="icon_details">
                                  <p>+919821867344</p>
                                  <span>Call Us</span>
                                </div>
                              </div>
                              <div className="icon_content">
                                <img src={internet1} alt="internet logo" />
                                <div className="icon_details">
                                  <p>https://www.easygosms.com/</p>
                                  <span>Website </span>
                                </div>
                              </div>
                              <div className="icon_content">
                                <img src={email1} alt="email logo" />
                                <div className="icon_details">
                                  <p>support@easygosms.com</p>
                                  <span>Email ID</span>
                                </div>
                              </div>
                            </div>
                          )}
                          {selectedTab === 'optionsTab' && (
                            <div className="options-tab-content">
                              <div className="info-tab-content">
                                <div className="icon_content">

                                  <div className="icon_details">
                                    <p>Notification</p>
                                  </div>
                                </div>
                                <div className="icon_content">

                                  <div className="icon_details">
                                    <p>Block & report spam</p>

                                  </div>
                                </div>
                                <div className="icon_content">

                                  <div className="icon_details">
                                    <p>View Privacy Policy</p>
                                  </div>
                                </div>
                                <div className="icon_content">

                                  <div className="icon_details">
                                    <p>View Terms of Services</p>
                                  </div>
                                </div>
                                <div className="icon_content">

                                  <div className="icon_details">
                                    <p>Learn more</p>
                                  </div>
                                </div>
                              </div>
                            </div>
                          )}
                        </div>


                      </div>
                    )}
                  </div>
                </div>

              </div>
            </div>
          </div>

          <div className="template_footer_content">
            <div className="temp_btn_box">
              <label htmlFor="Height">
                Suggested Actions/Reply Button<span className="required_icon">*</span>{" "}
                <div className="info-icon info-icon1">
                  <div className="tooltip tooltip1 tooltip_t">
                    You can add variables for Suggestion Text, Suggestion Postback and URL/URI. Please note that the variable will utilise 10 characters from the available character limit. You need to rename the [custom_param] to the variable name that will be passed via the API.
                    Please ensure that the character limit is preserved even when the variable’s length is added. Otherwise, the message may not be displayed correctly.
                    For URL/URI please ensure you have base URL/smsto: as the base before adding variables as suffixes. For eg., https://sampleurl.com/demos/ can be the base URL followed by [event]. So the full URL will be: https://sampleurl.com/demos/[event]
                    To Add a Google Wallet link please use the URL Action Suggestion type and use the following text in the text field: “Add to Google Wallet”.
                  </div>
                </div>
              </label>
              <button className="add_suggestion" onClick={handleAddSuggestion}> + Add Suggestion</button>
            </div>

            {
              (() => {

                if (isCategory === "carousel") {
                  // Access the corresponding category from the state
                  const categoryData = suggestions[isCategory];

                  // console.log('ssssss: ', suggestions);


                  if (categoryData) {
                    // console.log('isCategory:', isCategory);
                    // console.log('suggestions:', suggestions);
                    // console.log(`${isCategory} Data:`, categoryData);

                    // Check if the selected card has any suggestions
                    const activeCard = categoryData.card_suggestion.find(card => card.card_number === selectedCardId);

                    // If there is no active card or no suggestions for it
                    if (!activeCard || activeCard.suggestion.length === 0) {
                      return (
                        <div className="suggestion_div">
                          <h3>There are no Suggested actions yet </h3>
                        </div>
                      );
                    } else {
                      return (
                        <div className="suggestion_container">
                          {activeCard.suggestion.map((suggestion) => (
                            <div key={suggestion.id} className={`${suggestion.id} suggestion_box`}>
                              <div className="row">
                                <div className="col-12 col-lg-4">
                                  <div className="form_group">
                                    <label>Type of Action</label>
                                    <select
                                      value={suggestion.selectedAction}
                                      // onChange={(e) => handleActionChange(suggestion.id, e)}
                                      onChange={(e) => handleSuggestionField(suggestion.id, "selectedAction", e.target.value)}
                                    >
                                      <option value="Reply">Reply</option>
                                      <option value="URL_Action">URL Action</option>
                                      <option value="Dialer_Action">Dialer Action</option>
                                      {/* <option value="View_Location">View Location (Lat/Long)</option>
                                      <option value="View_Location_Query">View Location (Query)</option>
                                      <option value="Share_Location">Share Location</option>
                                      <option value="Create_Calendar_Event">Create Calendar Event</option> */}
                                    </select>
                                  </div>
                                </div>
                                <div className="col-12 col-lg-4">
                                  <div className="form_group from_input_var">
                                    <label>Suggestion Text</label>
                                    <input
                                      type="text"
                                      value={suggestion.suggestionText}
                                      // onChange={(e) => handleSuggestionTextChange(suggestion.id, e)}
                                      onChange={(e) => handleSuggestionField(suggestion.id, "suggestionText", e.target.value)}
                                    />
                                    <div className="chars_msg1 chars_msg2">
                                      {suggestion.suggestionText.length}/{maxchar25} chars used
                                    </div>
                                    <div
                                      className="chars_msg chars_msg_btn chars_msg_btnn"
                                      onClick={() => handleAddsuggestionVariable(suggestion.id, 'suggestionText')}
                                    >
                                      + Add Variable
                                    </div>
                                  </div>
                                </div>
                                <div className="col-12 col-lg-4">
                                  <div className="form_group from_input_var">
                                    <label>Suggestion Postback</label>
                                    <input
                                      type="text"
                                      value={suggestion.suggestionPostback}
                                      // onChange={(e) => handleSuggestionPostbackChange(suggestion.id, e)}
                                      onChange={(e) => handleSuggestionField(suggestion.id, "suggestionPostback", e.target.value)}
                                    />
                                    <div className="chars_msg1 chars_msg2">
                                      {suggestion.suggestionPostback.length}/{maxchar120} chars used
                                    </div>
                                    <div
                                      className="chars_msg chars_msg_btn chars_msg_btnn"
                                      onClick={() => handleAddsuggestionVariable(suggestion.id, 'suggestionPostback')}
                                    >
                                      + Add Variable
                                    </div>
                                  </div>
                                </div>
                              </div>

                              {/* Dynamic content based on selected action */}
                              <div className="action_content">
                                {suggestion.selectedAction === "URL_Action" && (
                                  <div className="col-12 col-lg-4">
                                    <div className="form_group from_input_var">
                                      <label>URL/URI to open</label>
                                      <input
                                        type="text"
                                        value={suggestion.urlAction || ""}
                                        // onChange={(e) => handleUrlChange(suggestion.id, e)}
                                        onChange={(e) => handleSuggestionField(suggestion.id, "urlAction", e.target.value)}
                                      />
                                      <div className="chars_msg1 chars_msg2">
                                        {suggestion.urlAction.length}/{maxchar2048} chars used
                                      </div>
                                      <div
                                        className="chars_msg chars_msg_btn chars_msg_btnn"
                                        onClick={() => handleAddsuggestionVariable(suggestion.id, 'urlAction')}
                                      >
                                        + Add Variable
                                      </div>
                                    </div>
                                  </div>
                                )}

                                {suggestion.selectedAction === "Dialer_Action" && (
                                  <div className="col-12 col-lg-4">
                                    <div className="form_group from_input_var">
                                      <label>Phone Number to Dial</label>

                                      <input
                                        type="text"
                                        // value={suggestion.dialerAction ? `+91${suggestion.dialerAction}` : '+91'}
                                        value={!suggestion.dialerAction ? "+91" : suggestion.dialerAction}
                                        onChange={(e) => {
                                          const value = e.target.value;
                                          // Remove +91 prefix and any non-digits
                                          // const phoneNumber = value.replace(/^\d+$/ , "");
                                          handleSuggestionField(suggestion.id, "dialerAction", value);
                                        }}
                                        onKeyDown={(e) => {
                                          // Prevent backspace from removing +91
                                          if (e.key === 'Backspace' && e.target.value.length <= 3) {
                                            e.preventDefault();
                                          }
                                        }}
                                        onFocus={(e) => {
                                          // Place cursor at end when focusing
                                          const end = e.target.value.length;
                                          e.target.setSelectionRange(end, end);
                                        }}
                                      // maxLength="13"  
                                      />
                                      <div className="chars_msg1 chars_msg2">
                                        {suggestion.dialerAction.length}/{maxChar13} chars used
                                      </div>
                                      {/* <div
                                        className="chars_msg chars_msg_btn chars_msg_btnn"
                                        onClick={() => handleAddsuggestionVariable(suggestion.id, 'dialerAction')}
                                      >
                                        + Add Variable
                                      </div> */}
                                    </div>
                                  </div>
                                )}

                                {suggestion.selectedAction === "View_Location" && (
                                  <div className="action_div">
                                    <div className="col-12 col-lg-4">
                                      <div className="form_group from_input_var">
                                        <label>Latitude</label>
                                        <input
                                          type="text"
                                          value={suggestion.latitude || ""}
                                          // onChange={(e) => handleLatitudeChange(suggestion.id, e)}
                                          onChange={(e) => handleSuggestionField(suggestion.id, "latitude", e.target.value)}
                                        />
                                      </div>
                                    </div>
                                    <div className="col-12 col-lg-4">
                                      <div className="form_group from_input_var">
                                        <label>Longitude</label>
                                        <input
                                          type="text"
                                          value={suggestion.longitude || ""}
                                          // onChange={(e) => handleLongitudeChange(suggestion.id, e)}
                                          onChange={(e) => handleSuggestionField(suggestion.id, "longitude", e.target.value)}
                                        />
                                      </div>
                                    </div>

                                    <div className="col-12 col-lg-4">
                                      <div className="form_group from_input_var">
                                        <label htmlFor="HorizontalPosition">Label</label>
                                        <input
                                          type="text"
                                          value={suggestion.label || ""}
                                          // onChange={(e) => handleLableChange(suggestion.id, e)}
                                          onChange={(e) => handleSuggestionField(suggestion.id, "label", e.target.value)}
                                        />
                                        <div className="chars_msg1 chars_msg2">
                                          {suggestion.label.length}/{maxchar25} chars used
                                        </div>
                                      </div>
                                    </div>
                                  </div>
                                )}

                                {suggestion.selectedAction === "Create_Calendar_Event" && (
                                  <div className="action_div">
                                    <div className="col-12 col-lg-4">
                                      <div className="form_group from_input_var">
                                        <label>Event Date & Time</label>
                                        <input
                                          type="datetime-local"
                                          value={suggestion.eventDateTime ? suggestion.eventDateTime.slice(0, 16) : ""}
                                          onChange={(e) => {
                                            const selectedDateTime = e.target.value;
                                            const formattedDateTime = new Date(selectedDateTime).toISOString().slice(0, 16);
                                            // Update the suggestion's eventDateTime with the selected date-time
                                            handleSuggestionField(suggestion.id, "eventDateTime", formattedDateTime);
                                          }}
                                        />
                                      </div>
                                    </div>
                                    <div className="col-12 col-lg-4">
                                      <div className="form_group from_input_var">
                                        <label>Event Title</label>
                                        <input
                                          type="text"
                                          value={suggestion.eventTitle || ""}
                                          // onChange={(e) => handleEventTitleChange(suggestion.id, e)}
                                          onChange={(e) =>
                                            handleSuggestionField(suggestion.id, "eventTitle", e.target.value)}
                                        />
                                        <div className="chars_msg1 chars_msg2">
                                          {suggestion.eventTitle.length}/{maxchar2048} chars used
                                        </div>
                                      </div>
                                    </div>
                                    <div className="col-12 col-lg-4">
                                      <div className="form_group from_input_var">
                                        <label>Event Description</label>
                                        <input
                                          type="text"
                                          value={suggestion.eventDescription || ""}
                                          // onChange={(e) => handleEventDescriptionChange(suggestion.id, e)}
                                          onChange={(e) => handleSuggestionField(suggestion.id, "eventDescription", e.target.value)}
                                        />
                                        <div className="chars_msg1 chars_msg2">
                                          {suggestion.eventDescription.length}/{maxchar2048} chars used
                                        </div>
                                      </div>
                                    </div>
                                  </div>
                                )}
                              </div>

                              <button className="close_button" onClick={() => handleRemoveSuggestion(suggestion.id)}>
                                ✖
                              </button>
                            </div>
                          ))}
                        </div>
                      );
                    }
                  }
                }
                // Add Suggestions for Other Category                                   
                // Add Suggestions for Other Category                                   
                else {
                  // Access the specific category in the suggestions object
                  const OtherSuggestionCatg = suggestions[isCategory];

                  // console.log('ssssss: ', suggestions);
                  // console.log('OtherSuggestionCatg222: ', OtherSuggestionCatg);

                  if (OtherSuggestionCatg) {
                    // Check if there are any suggestions for the specific category
                    if (OtherSuggestionCatg.suggestion.length === 0) {
                      return (
                        <div className="suggestion_div">
                          <h3>There are no Suggested actions yet.</h3>
                        </div>
                      );
                    } else {
                      return (
                        <div className="suggestion_container">
                          {OtherSuggestionCatg.suggestion.map((suggestion) => (
                            <div key={suggestion.id} className={`${suggestion.id} suggestion_box`}>
                              <div className="row">
                                <div className="col-12 col-lg-4">
                                  <div className="form_group">
                                    <label>Type of Action</label>
                                    <select
                                      value={suggestion.selectedAction}
                                      // onChange={(e) => handleActionChange(suggestion.id, e)}
                                      onChange={(e) => handleSuggestionField(suggestion.id, "selectedAction", e.target.value)}

                                    >
                                      <option value="Reply">Reply</option>
                                      <option value="URL_Action">URL Action</option>
                                      <option value="Dialer_Action">Dialer Action</option>
                                      {/* <option value="View_Location">View Location (Lat/Long)</option>
                                      <option value="View_Location_Query">View Location (Query)</option>
                                      <option value="Share_Location">Share Location</option>
                                      <option value="Create_Calendar_Event">Create Calendar Event</option> */}
                                    </select>
                                  </div>
                                </div>
                                <div className="col-12 col-lg-4">
                                  <div className="form_group from_input_var">
                                    <label>Suggestion Text</label>
                                    <input
                                      type="text"
                                      value={suggestion.suggestionText}
                                      // onChange={(e) => handleSuggestionTextChange(suggestion.id, e)}
                                      onChange={(e) => handleSuggestionField(suggestion.id, "suggestionText", e.target.value)}

                                    />
                                    <div className="chars_msg1 chars_msg2">
                                      {suggestion.suggestionText.length}/{maxchar25} chars used
                                    </div>
                                    <div
                                      className="chars_msg chars_msg_btn chars_msg_btnn"
                                      onClick={() => handleAddsuggestionVariable(suggestion.id, 'suggestionText')}
                                    >
                                      + Add Variable
                                    </div>
                                  </div>
                                </div>
                                <div className="col-12 col-lg-4">
                                  <div className="form_group from_input_var">
                                    <label>Suggestion Postback</label>
                                    <input
                                      type="text"
                                      value={suggestion.suggestionPostback}
                                      // onChange={(e) => handleSuggestionPostbackChange(suggestion.id, e)}
                                      onChange={(e) => handleSuggestionField(suggestion.id, "suggestionPostback", e.target.value)}
                                    />
                                    <div className="chars_msg1 chars_msg2">
                                      {suggestion.suggestionPostback.length}/{maxchar120} chars used
                                    </div>
                                    <div
                                      className="chars_msg chars_msg_btn chars_msg_btnn"
                                      onClick={() => handleAddsuggestionVariable(suggestion.id, 'suggestionPostback')}
                                    >
                                      + Add Variable
                                    </div>
                                  </div>
                                </div>
                              </div>

                              {/* Dynamic content based on selected action */}
                              <div className="action_content">
                                {suggestion.selectedAction === 'URL_Action' && (
                                  <div className="col-12 col-lg-4">
                                    <div className="form_group from_input_var">
                                      <label>URL/URI to open</label>
                                      <input
                                        type="text"
                                        value={suggestion.urlAction || ''}
                                        // onChange={(e) => handleUrlChange(suggestion.id, e)}
                                        onChange={(e) => handleSuggestionField(suggestion.id, "urlAction", e.target.value)}
                                      />
                                      <div className="chars_msg1 chars_msg2">
                                        {suggestion.urlAction.length}/{maxchar2048} chars used
                                      </div>
                                      <div
                                        className="chars_msg chars_msg_btn chars_msg_btnn"
                                        onClick={() => handleAddsuggestionVariable(suggestion.id, 'urlAction')}
                                      >
                                        + Add Variable
                                      </div>
                                    </div>
                                  </div>
                                )}

                                {suggestion.selectedAction === 'Dialer_Action' && (
                                  <div className="col-12 col-lg-4">
                                    <div className="form_group from_input_var">
                                      <label>Phone Number to Dial</label>

                                      <input
                                        type="text"
                                        // value={suggestion.dialerAction ? `+91${suggestion.dialerAction}` : '+91'}
                                        value={!suggestion.dialerAction ? "+91" : suggestion.dialerAction}
                                        onChange={(e) => {
                                          const value = e.target.value;
                                          // Remove +91 prefix and any non-digits
                                          // const phoneNumber = value.replace(/^\d+$/ , "");
                                          handleSuggestionField(suggestion.id, "dialerAction", value);
                                        }}
                                        onKeyDown={(e) => {
                                          // Prevent backspace from removing +91
                                          if (e.key === 'Backspace' && e.target.value.length <= 3) {
                                            e.preventDefault();
                                          }
                                        }}
                                        onFocus={(e) => {
                                          // Place cursor at end when focusing
                                          const end = e.target.value.length;
                                          e.target.setSelectionRange(end, end);
                                        }}
                                      // maxLength="13"  
                                      />


                                      <div className="chars_msg1 chars_msg2">
                                        {suggestion.dialerAction.length}/{maxChar13} chars used
                                      </div>
                                      {/* <div
                                        className="chars_msg chars_msg_btn chars_msg_btnn"
                                        onClick={() => handleAddsuggestionVariable(suggestion.id, 'dialerAction')}
                                      >
                                        + Add Variable
                                      </div> */}
                                    </div>
                                  </div>
                                )}

                                {suggestion.selectedAction === 'View_Location' && (
                                  <div className="action_div">
                                    <div className="col-12 col-lg-4">
                                      <div className="form_group from_input_var">
                                        <label>Latitude</label>
                                        <input
                                          type="text"
                                          value={suggestion.latitude || ''}
                                          // onChange={(e) => handleLatitudeChange(suggestion.id, e)}
                                          onChange={(e) => handleSuggestionField(suggestion.id, "latitude", e.target.value)}
                                        />
                                      </div>
                                    </div>
                                    <div className="col-12 col-lg-4">
                                      <div className="form_group from_input_var">
                                        <label>Longitude</label>
                                        <input
                                          type="text"
                                          value={suggestion.longitude || ''}
                                          // onChange={(e) => handleLongitudeChange(suggestion.id, e)}
                                          onChange={(e) => handleSuggestionField(suggestion.id, "longitude", e.target.value)}
                                        />
                                      </div>
                                    </div>

                                    <div className="col-12 col-lg-4">
                                      <div className="form_group from_input_var">
                                        <label htmlFor="HorizontalPosition">Label</label>
                                        <input
                                          type="text"
                                          value={suggestion.label || ''}
                                          // onChange={(e) => handleLableChange(suggestion.id, e)}
                                          onChange={(e) => handleSuggestionField(suggestion.id, "label", e.target.value)}
                                        />

                                        <div className="chars_msg1 chars_msg2">
                                          {suggestion.label.length}/{maxchar25} chars used
                                        </div>
                                      </div>
                                    </div>
                                  </div>
                                )}

                                {suggestion.selectedAction === 'Create_Calendar_Event' && (
                                  <div className="action_div">
                                    <div className="col-12 col-lg-4">
                                      <div className="form_group from_input_var">
                                        <label>Event Date & Time</label>
                                        <input
                                          type="datetime-local"
                                          value={suggestion.eventDateTime ? suggestion.eventDateTime.slice(0, 16) : ""}
                                          onChange={(e) => {
                                            const selectedDateTime = e.target.value;
                                            const formattedDateTime = new Date(selectedDateTime).toISOString().slice(0, 16);
                                            // Update the suggestion's eventDateTime with the selected date-time
                                            handleSuggestionField(suggestion.id, "eventDateTime", formattedDateTime);
                                          }}
                                        />
                                      </div>
                                    </div>
                                    <div className="col-12 col-lg-4">
                                      <div className="form_group from_input_var">
                                        <label>Event Title</label>
                                        <input
                                          type="text"
                                          value={suggestion.eventTitle || ''}
                                          // onChange={(e) => handleEventTitleChange(suggestion.id, e)}
                                          onChange={(e) => handleSuggestionField(suggestion.id, "eventTitle", e.target.value)}
                                        />
                                        <div className="chars_msg1 chars_msg2">
                                          {suggestion.eventTitle.length}/{maxchar2048} chars used
                                        </div>
                                      </div>
                                    </div>
                                    <div className="col-12 col-lg-4">
                                      <div className="form_group from_input_var">
                                        <label>Event Description</label>
                                        <input
                                          type="text"
                                          value={suggestion.eventDescription || ''}
                                          // onChange={(e) => handleEventDescriptionChange(suggestion.id, e)}
                                          onChange={(e) => handleSuggestionField(suggestion.id, "eventDescription", e.target.value)}
                                        />
                                        <div className="chars_msg1 chars_msg2">
                                          {suggestion.eventDescription.length}/{maxchar2048} chars used
                                        </div>
                                      </div>
                                    </div>
                                  </div>
                                )}
                              </div>

                              <button
                                className="close_button"
                                onClick={() => handleRemoveSuggestion(suggestion.id)}
                              >
                                ✖
                              </button>
                            </div>
                          ))}
                        </div>
                      );
                    }
                  }
                }


              })()
            }

            {/* thumbnail */}
            <input type="file" src={thumbnail} ref={thumbnailRef} alt="thumbnail image" hidden />
            <input type="file" src={thumbnailCarousel} ref={thumbnailCarouselRef} alt="Carousel thumbnail image" hidden />

            <input type="file" src={mediaFileTest} ref={mediaFileTestRef} alt="" hidden />


            <div className="submit_btn_box">
              <button onClick={resetTemplateFields}>Cancel</button>
              {/* <button>Create</button> */}
              <button onClick={submitForApproval}>Submit for Approval</button>
            </div>
          </div>
        </div>
      </div>

      {loading && (
        <div className="spinnerOverlay">
          <ClipLoader loading={loading} size={50} />
        </div>
      )}

    </>
  );
}

export default WbAddTemplate1;
